(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'okio-parent-okio'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'okio-parent-okio'.");
    }
    globalThis['okio-parent-okio'] = factory(typeof globalThis['okio-parent-okio'] === 'undefined' ? {} : globalThis['okio-parent-okio'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toMap = kotlin_kotlin.$_$.nc;
  var protoOf = kotlin_kotlin.$_$.eh;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var toString = kotlin_kotlin.$_$.hh;
  var joinToString = kotlin_kotlin.$_$.aa;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.n5;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var subtract = kotlin_kotlin.$_$.af;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var Char__compareTo_impl_ypi4mb = kotlin_kotlin.$_$.r;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var toByte = kotlin_kotlin.$_$.fh;
  var copyOf = kotlin_kotlin.$_$.s8;
  var charArray = kotlin_kotlin.$_$.if;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var concatToString = kotlin_kotlin.$_$.mj;
  var fromInt = kotlin_kotlin.$_$.pe;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var add = kotlin_kotlin.$_$.fe;
  var numberToLong = kotlin_kotlin.$_$.we;
  var convertToInt = kotlin_kotlin.$_$.le;
  var countLeadingZeroBits = kotlin_kotlin.$_$.ho;
  var longArrayOf = kotlin_kotlin.$_$.vg;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var Char = kotlin_kotlin.$_$.ym;
  var equals = kotlin_kotlin.$_$.sf;
  var removeLastOrNull = kotlin_kotlin.$_$.nb;
  var last = kotlin_kotlin.$_$.na;
  var fill = kotlin_kotlin.$_$.h9;
  var fill_0 = kotlin_kotlin.$_$.f9;
  var multiply = kotlin_kotlin.$_$.ue;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var convertToByte = kotlin_kotlin.$_$.ke;
  var copyOfRange = kotlin_kotlin.$_$.n8;
  var concatToString_0 = kotlin_kotlin.$_$.lj;
  var contentHashCode = kotlin_kotlin.$_$.i8;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var substring = kotlin_kotlin.$_$.pl;
  var replace = kotlin_kotlin.$_$.xk;
  var Comparable = kotlin_kotlin.$_$.an;
  var copyOfRange_0 = kotlin_kotlin.$_$.m8;
  var negate = kotlin_kotlin.$_$.ve;
  var modulo = kotlin_kotlin.$_$.te;
  var divide = kotlin_kotlin.$_$.ne;
  var AssertionError_init_$Create$ = kotlin_kotlin.$_$.z4;
  var isArray = kotlin_kotlin.$_$.jg;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.j5;
  var IndexOutOfBoundsException = kotlin_kotlin.$_$.jn;
  var IndexOutOfBoundsException_init_$Init$ = kotlin_kotlin.$_$.z5;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(FileMetadata, 'FileMetadata', FileMetadata);
  initMetadataForClass(FileSystem, 'FileSystem');
  initMetadataForClass(ForwardingFileSystem, 'ForwardingFileSystem', VOID, FileSystem);
  initMetadataForClass(BlackholeSink, 'BlackholeSink', BlackholeSink);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Segment, 'Segment', Segment_init_$Create$);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(Sha256, 'Sha256', Sha256);
  initMetadataForCompanion(Companion_1);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(ByteString, 'ByteString', VOID, VOID, [Comparable]);
  initMetadataForClass(SegmentedByteString, 'SegmentedByteString', VOID, ByteString);
  initMetadataForClass(Buffer, 'Buffer', Buffer);
  initMetadataForClass(IOException, 'IOException', IOException_init_$Create$_0, Exception);
  initMetadataForClass(EOFException, 'EOFException', EOFException_init_$Create$, IOException);
  initMetadataForClass(ArrayIndexOutOfBoundsException, 'ArrayIndexOutOfBoundsException', VOID, IndexOutOfBoundsException);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(Path, 'Path', VOID, VOID, [Comparable]);
  initMetadataForClass(RealBufferedSink, 'RealBufferedSink');
  initMetadataForClass(RealBufferedSource, 'RealBufferedSource');
  initMetadataForObject(SegmentPool, 'SegmentPool');
  //endregion
  function FileMetadata(isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras) {
    isRegularFile = isRegularFile === VOID ? false : isRegularFile;
    isDirectory = isDirectory === VOID ? false : isDirectory;
    symlinkTarget = symlinkTarget === VOID ? null : symlinkTarget;
    size = size === VOID ? null : size;
    createdAtMillis = createdAtMillis === VOID ? null : createdAtMillis;
    lastModifiedAtMillis = lastModifiedAtMillis === VOID ? null : lastModifiedAtMillis;
    lastAccessedAtMillis = lastAccessedAtMillis === VOID ? null : lastAccessedAtMillis;
    var tmp;
    if (extras === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = extras;
    }
    extras = tmp;
    this.qvo_1 = isRegularFile;
    this.rvo_1 = isDirectory;
    this.svo_1 = symlinkTarget;
    this.tvo_1 = size;
    this.uvo_1 = createdAtMillis;
    this.vvo_1 = lastModifiedAtMillis;
    this.wvo_1 = lastAccessedAtMillis;
    this.xvo_1 = toMap(extras);
  }
  protoOf(FileMetadata).yvo = function (isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras) {
    return new FileMetadata(isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras);
  };
  protoOf(FileMetadata).zvo = function (isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras, $super) {
    isRegularFile = isRegularFile === VOID ? this.qvo_1 : isRegularFile;
    isDirectory = isDirectory === VOID ? this.rvo_1 : isDirectory;
    symlinkTarget = symlinkTarget === VOID ? this.svo_1 : symlinkTarget;
    size = size === VOID ? this.tvo_1 : size;
    createdAtMillis = createdAtMillis === VOID ? this.uvo_1 : createdAtMillis;
    lastModifiedAtMillis = lastModifiedAtMillis === VOID ? this.vvo_1 : lastModifiedAtMillis;
    lastAccessedAtMillis = lastAccessedAtMillis === VOID ? this.wvo_1 : lastAccessedAtMillis;
    extras = extras === VOID ? this.xvo_1 : extras;
    return $super === VOID ? this.yvo(isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras) : $super.yvo.call(this, isRegularFile, isDirectory, symlinkTarget, size, createdAtMillis, lastModifiedAtMillis, lastAccessedAtMillis, extras);
  };
  protoOf(FileMetadata).toString = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var fields = ArrayList_init_$Create$();
    if (this.qvo_1) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element = 'isRegularFile';
      fields.j1(element);
    }
    if (this.rvo_1) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = 'isDirectory';
      fields.j1(element_0);
    }
    if (!(this.tvo_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_1 = 'byteCount=' + this.tvo_1.toString();
      fields.j1(element_1);
    }
    if (!(this.uvo_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_2 = 'createdAt=' + this.uvo_1.toString();
      fields.j1(element_2);
    }
    if (!(this.vvo_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_3 = 'lastModifiedAt=' + this.vvo_1.toString();
      fields.j1(element_3);
    }
    if (!(this.wvo_1 == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_4 = 'lastAccessedAt=' + this.wvo_1.toString();
      fields.j1(element_4);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.xvo_1.r()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_5 = 'extras=' + toString(this.xvo_1);
      fields.j1(element_5);
    }
    return joinToString(fields, ', ', 'FileMetadata(', ')');
  };
  function ForwardingFileSystem(delegate) {
    FileSystem.call(this);
    this.avp_1 = delegate;
  }
  protoOf(ForwardingFileSystem).bvp = function (path, functionName, parameterName) {
    return path;
  };
  protoOf(ForwardingFileSystem).cvp = function (path, functionName) {
    return path;
  };
  protoOf(ForwardingFileSystem).dvp = function (path) {
    var path_0 = this.bvp(path, 'metadataOrNull', 'path');
    var tmp0_elvis_lhs = this.avp_1.dvp(path_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var metadataOrNull = tmp;
    if (metadataOrNull.svo_1 == null)
      return metadataOrNull;
    var symlinkTarget = this.cvp(metadataOrNull.svo_1, 'metadataOrNull');
    return metadataOrNull.zvo(VOID, VOID, symlinkTarget);
  };
  protoOf(ForwardingFileSystem).evp = function (file) {
    var file_0 = this.bvp(file, 'source', 'file');
    return this.avp_1.evp(file_0);
  };
  protoOf(ForwardingFileSystem).fvp = function (file, mustCreate) {
    var file_0 = this.bvp(file, 'sink', 'file');
    return this.avp_1.fvp(file_0, mustCreate);
  };
  protoOf(ForwardingFileSystem).gvp = function (file, mustExist) {
    var file_0 = this.bvp(file, 'appendingSink', 'file');
    return this.avp_1.gvp(file_0, mustExist);
  };
  protoOf(ForwardingFileSystem).ivp = function (dir, mustCreate) {
    var dir_0 = this.bvp(dir, 'createDirectory', 'dir');
    this.avp_1.ivp(dir_0, mustCreate);
  };
  protoOf(ForwardingFileSystem).kvp = function (source, target) {
    var source_0 = this.bvp(source, 'atomicMove', 'source');
    var target_0 = this.bvp(target, 'atomicMove', 'target');
    this.avp_1.kvp(source_0, target_0);
  };
  protoOf(ForwardingFileSystem).lvp = function (path, mustExist) {
    var path_0 = this.bvp(path, 'delete', 'path');
    this.avp_1.lvp(path_0, mustExist);
  };
  protoOf(ForwardingFileSystem).j4 = function () {
    this.avp_1.j4();
  };
  protoOf(ForwardingFileSystem).toString = function () {
    return '' + getKClassFromExpression(this).o() + '(' + toString(this.avp_1) + ')';
  };
  function buffer(_this__u8e3s4) {
    return new RealBufferedSource(_this__u8e3s4);
  }
  function buffer_0(_this__u8e3s4) {
    return new RealBufferedSink(_this__u8e3s4);
  }
  function blackholeSink() {
    return new BlackholeSink();
  }
  function BlackholeSink() {
  }
  protoOf(BlackholeSink).qvp = function (source, byteCount) {
    return source.is8(byteCount);
  };
  protoOf(BlackholeSink).k9 = function () {
  };
  protoOf(BlackholeSink).j4 = function () {
  };
  function Segment_init_$Init$($this) {
    Segment.call($this);
    $this.tvp_1 = new Int8Array(8192);
    $this.xvp_1 = true;
    $this.wvp_1 = false;
    return $this;
  }
  function Segment_init_$Create$() {
    return Segment_init_$Init$(objectCreate(protoOf(Segment)));
  }
  function Segment_init_$Init$_0(data, pos, limit, shared, owner, $this) {
    Segment.call($this);
    $this.tvp_1 = data;
    $this.uvp_1 = pos;
    $this.vvp_1 = limit;
    $this.wvp_1 = shared;
    $this.xvp_1 = owner;
    return $this;
  }
  function Segment_init_$Create$_0(data, pos, limit, shared, owner) {
    return Segment_init_$Init$_0(data, pos, limit, shared, owner, objectCreate(protoOf(Segment)));
  }
  function Companion() {
    this.avq_1 = 8192;
    this.bvq_1 = 1024;
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  protoOf(Segment).cvq = function () {
    this.wvp_1 = true;
    return Segment_init_$Create$_0(this.tvp_1, this.uvp_1, this.vvp_1, true, false);
  };
  protoOf(Segment).k3j = function () {
    var result = !(this.yvp_1 === this) ? this.yvp_1 : null;
    ensureNotNull(this.zvp_1).yvp_1 = this.yvp_1;
    ensureNotNull(this.yvp_1).zvp_1 = this.zvp_1;
    this.yvp_1 = null;
    this.zvp_1 = null;
    return result;
  };
  protoOf(Segment).dvq = function (segment) {
    segment.zvp_1 = this;
    segment.yvp_1 = this.yvp_1;
    ensureNotNull(this.yvp_1).zvp_1 = segment;
    this.yvp_1 = segment;
    return segment;
  };
  protoOf(Segment).evq = function (byteCount) {
    // Inline function 'kotlin.require' call
    if (!(byteCount > 0 && byteCount <= (this.vvp_1 - this.uvp_1 | 0))) {
      var message = 'byteCount out of range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var prefix;
    if (byteCount >= 1024) {
      prefix = this.cvq();
    } else {
      prefix = SegmentPool_instance.ss8();
      var tmp0 = this.tvp_1;
      var tmp2 = prefix.tvp_1;
      var tmp5 = this.uvp_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.uvp_1 + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
    }
    prefix.vvp_1 = prefix.uvp_1 + byteCount | 0;
    this.uvp_1 = this.uvp_1 + byteCount | 0;
    ensureNotNull(this.zvp_1).dvq(prefix);
    return prefix;
  };
  protoOf(Segment).hvq = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.zvp_1 === this)) {
      var message = 'cannot compact';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (!ensureNotNull(this.zvp_1).xvp_1)
      return Unit_instance;
    var byteCount = this.vvp_1 - this.uvp_1 | 0;
    var availableByteCount = (8192 - ensureNotNull(this.zvp_1).vvp_1 | 0) + (ensureNotNull(this.zvp_1).wvp_1 ? 0 : ensureNotNull(this.zvp_1).uvp_1) | 0;
    if (byteCount > availableByteCount)
      return Unit_instance;
    this.ivq(ensureNotNull(this.zvp_1), byteCount);
    this.k3j();
    SegmentPool_instance.jvq(this);
  };
  protoOf(Segment).ivq = function (sink, byteCount) {
    // Inline function 'kotlin.check' call
    if (!sink.xvp_1) {
      var message = 'only owner can write';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if ((sink.vvp_1 + byteCount | 0) > 8192) {
      if (sink.wvp_1)
        throw IllegalArgumentException_init_$Create$_0();
      if (((sink.vvp_1 + byteCount | 0) - sink.uvp_1 | 0) > 8192)
        throw IllegalArgumentException_init_$Create$_0();
      var tmp0 = sink.tvp_1;
      var tmp2 = sink.tvp_1;
      var tmp5 = sink.uvp_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = sink.vvp_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
      sink.vvp_1 = sink.vvp_1 - sink.uvp_1 | 0;
      sink.uvp_1 = 0;
    }
    var tmp0_0 = this.tvp_1;
    var tmp2_0 = sink.tvp_1;
    var tmp4 = sink.vvp_1;
    var tmp6 = this.uvp_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = this.uvp_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = tmp0_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
    sink.vvp_1 = sink.vvp_1 + byteCount | 0;
    this.uvp_1 = this.uvp_1 + byteCount | 0;
  };
  function Segment() {
    this.uvp_1 = 0;
    this.vvp_1 = 0;
    this.wvp_1 = false;
    this.xvp_1 = false;
    this.yvp_1 = null;
    this.zvp_1 = null;
  }
  function checkOffsetAndCount(size, offset, byteCount) {
    if (compare(bitwiseOr(offset, byteCount), new Long(0, 0)) < 0 || compare(offset, size) > 0 || compare(subtract(size, offset), byteCount) < 0) {
      throw new ArrayIndexOutOfBoundsException('size=' + size.toString() + ' offset=' + offset.toString() + ' byteCount=' + byteCount.toString());
    }
  }
  function arrayRangeEquals(a, aOffset, b, bOffset, byteCount) {
    var inductionVariable = 0;
    if (inductionVariable < byteCount)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(a[i + aOffset | 0] === b[i + bOffset | 0]))
          return false;
      }
       while (inductionVariable < byteCount);
    return true;
  }
  function commonAsUtf8ToByteArray(_this__u8e3s4) {
    var bytes = new Int8Array(imul(4, _this__u8e3s4.length));
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b0 = charCodeAt(_this__u8e3s4, index);
        if (Char__compareTo_impl_ypi4mb(b0, _Char___init__impl__6a9atx(128)) >= 0) {
          var size = index;
          // Inline function 'okio.processUtf8Bytes' call
          var endIndex = _this__u8e3s4.length;
          var index_0 = index;
          while (index_0 < endIndex) {
            var c = charCodeAt(_this__u8e3s4, index_0);
            if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(128)) < 0) {
              // Inline function 'kotlin.code' call
              var tmp$ret$1 = Char__toInt_impl_vasixd(c);
              var c_0 = toByte(tmp$ret$1);
              var _unary__edvuaz = size;
              size = _unary__edvuaz + 1 | 0;
              bytes[_unary__edvuaz] = c_0;
              index_0 = index_0 + 1 | 0;
              while (index_0 < endIndex && Char__compareTo_impl_ypi4mb(charCodeAt(_this__u8e3s4, index_0), _Char___init__impl__6a9atx(128)) < 0) {
                var _unary__edvuaz_0 = index_0;
                index_0 = _unary__edvuaz_0 + 1 | 0;
                // Inline function 'kotlin.code' call
                var this_0 = charCodeAt(_this__u8e3s4, _unary__edvuaz_0);
                var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
                var c_1 = toByte(tmp$ret$3);
                var _unary__edvuaz_1 = size;
                size = _unary__edvuaz_1 + 1 | 0;
                bytes[_unary__edvuaz_1] = c_1;
              }
            } else if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(2048)) < 0) {
              // Inline function 'kotlin.code' call
              var tmp$ret$5 = Char__toInt_impl_vasixd(c);
              var c_2 = toByte(tmp$ret$5 >> 6 | 192);
              var _unary__edvuaz_2 = size;
              size = _unary__edvuaz_2 + 1 | 0;
              bytes[_unary__edvuaz_2] = c_2;
              // Inline function 'kotlin.code' call
              var tmp$ret$7 = Char__toInt_impl_vasixd(c);
              var c_3 = toByte(tmp$ret$7 & 63 | 128);
              var _unary__edvuaz_3 = size;
              size = _unary__edvuaz_3 + 1 | 0;
              bytes[_unary__edvuaz_3] = c_3;
              index_0 = index_0 + 1 | 0;
            } else if (!(_Char___init__impl__6a9atx(55296) <= c ? c <= _Char___init__impl__6a9atx(57343) : false)) {
              // Inline function 'kotlin.code' call
              var tmp$ret$9 = Char__toInt_impl_vasixd(c);
              var c_4 = toByte(tmp$ret$9 >> 12 | 224);
              var _unary__edvuaz_4 = size;
              size = _unary__edvuaz_4 + 1 | 0;
              bytes[_unary__edvuaz_4] = c_4;
              // Inline function 'kotlin.code' call
              var tmp$ret$11 = Char__toInt_impl_vasixd(c);
              var c_5 = toByte(tmp$ret$11 >> 6 & 63 | 128);
              var _unary__edvuaz_5 = size;
              size = _unary__edvuaz_5 + 1 | 0;
              bytes[_unary__edvuaz_5] = c_5;
              // Inline function 'kotlin.code' call
              var tmp$ret$13 = Char__toInt_impl_vasixd(c);
              var c_6 = toByte(tmp$ret$13 & 63 | 128);
              var _unary__edvuaz_6 = size;
              size = _unary__edvuaz_6 + 1 | 0;
              bytes[_unary__edvuaz_6] = c_6;
              index_0 = index_0 + 1 | 0;
            } else {
              var tmp;
              if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(56319)) > 0 || endIndex <= (index_0 + 1 | 0)) {
                tmp = true;
              } else {
                var containsArg = charCodeAt(_this__u8e3s4, index_0 + 1 | 0);
                tmp = !(_Char___init__impl__6a9atx(56320) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57343) : false);
              }
              if (tmp) {
                var _unary__edvuaz_7 = size;
                size = _unary__edvuaz_7 + 1 | 0;
                bytes[_unary__edvuaz_7] = 63;
                index_0 = index_0 + 1 | 0;
              } else {
                // Inline function 'kotlin.code' call
                var tmp_0 = Char__toInt_impl_vasixd(c) << 10;
                // Inline function 'kotlin.code' call
                var this_1 = charCodeAt(_this__u8e3s4, index_0 + 1 | 0);
                var codePoint = (tmp_0 + Char__toInt_impl_vasixd(this_1) | 0) + -56613888 | 0;
                var c_7 = toByte(codePoint >> 18 | 240);
                var _unary__edvuaz_8 = size;
                size = _unary__edvuaz_8 + 1 | 0;
                bytes[_unary__edvuaz_8] = c_7;
                var c_8 = toByte(codePoint >> 12 & 63 | 128);
                var _unary__edvuaz_9 = size;
                size = _unary__edvuaz_9 + 1 | 0;
                bytes[_unary__edvuaz_9] = c_8;
                var c_9 = toByte(codePoint >> 6 & 63 | 128);
                var _unary__edvuaz_10 = size;
                size = _unary__edvuaz_10 + 1 | 0;
                bytes[_unary__edvuaz_10] = c_9;
                var c_10 = toByte(codePoint & 63 | 128);
                var _unary__edvuaz_11 = size;
                size = _unary__edvuaz_11 + 1 | 0;
                bytes[_unary__edvuaz_11] = c_10;
                index_0 = index_0 + 2 | 0;
              }
            }
          }
          return copyOf(bytes, size);
        }
        // Inline function 'kotlin.code' call
        var tmp$ret$22 = Char__toInt_impl_vasixd(b0);
        bytes[index] = toByte(tmp$ret$22);
      }
       while (inductionVariable < last);
    return copyOf(bytes, _this__u8e3s4.length);
  }
  function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
    beginIndex = beginIndex === VOID ? 0 : beginIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
      throw new ArrayIndexOutOfBoundsException('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
    }
    var chars = charArray(endIndex - beginIndex | 0);
    var length = 0;
    // Inline function 'okio.processUtf16Chars' call
    var index = beginIndex;
    while (index < endIndex) {
      var b0 = _this__u8e3s4[index];
      if (b0 >= 0) {
        var c = numberToChar(b0);
        var _unary__edvuaz = length;
        length = _unary__edvuaz + 1 | 0;
        chars[_unary__edvuaz] = c;
        index = index + 1 | 0;
        while (index < endIndex && _this__u8e3s4[index] >= 0) {
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          var c_0 = numberToChar(_this__u8e3s4[_unary__edvuaz_0]);
          var _unary__edvuaz_1 = length;
          length = _unary__edvuaz_1 + 1 | 0;
          chars[_unary__edvuaz_1] = c_0;
        }
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 5 === -2) {
          var tmp = index;
          var tmp2 = index;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'okio.process2Utf8Bytes' call
            if (endIndex <= (tmp2 + 1 | 0)) {
              var c_1 = numberToChar(65533);
              var _unary__edvuaz_2 = length;
              length = _unary__edvuaz_2 + 1 | 0;
              chars[_unary__edvuaz_2] = c_1;
              tmp$ret$4 = 1;
              break $l$block_0;
            }
            var b0_0 = _this__u8e3s4[tmp2];
            var b1 = _this__u8e3s4[tmp2 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1 & 192) === 128)) {
              var c_2 = numberToChar(65533);
              var _unary__edvuaz_3 = length;
              length = _unary__edvuaz_3 + 1 | 0;
              chars[_unary__edvuaz_3] = c_2;
              tmp$ret$4 = 1;
              break $l$block_0;
            }
            var codePoint = 3968 ^ b1 ^ b0_0 << 6;
            if (codePoint < 128) {
              var c_3 = numberToChar(65533);
              var _unary__edvuaz_4 = length;
              length = _unary__edvuaz_4 + 1 | 0;
              chars[_unary__edvuaz_4] = c_3;
            } else {
              var c_4 = numberToChar(codePoint);
              var _unary__edvuaz_5 = length;
              length = _unary__edvuaz_5 + 1 | 0;
              chars[_unary__edvuaz_5] = c_4;
            }
            tmp$ret$4 = 2;
          }
          index = tmp + tmp$ret$4 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 4 === -2) {
            var tmp_0 = index;
            var tmp2_0 = index;
            var tmp$ret$16;
            $l$block_4: {
              // Inline function 'okio.process3Utf8Bytes' call
              if (endIndex <= (tmp2_0 + 2 | 0)) {
                var c_5 = numberToChar(65533);
                var _unary__edvuaz_6 = length;
                length = _unary__edvuaz_6 + 1 | 0;
                chars[_unary__edvuaz_6] = c_5;
                var tmp_1;
                if (endIndex <= (tmp2_0 + 1 | 0)) {
                  tmp_1 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_1 = !((_this__u8e3s4[tmp2_0 + 1 | 0] & 192) === 128);
                }
                if (tmp_1) {
                  tmp$ret$16 = 1;
                  break $l$block_4;
                } else {
                  tmp$ret$16 = 2;
                  break $l$block_4;
                }
              }
              var b0_1 = _this__u8e3s4[tmp2_0];
              var b1_0 = _this__u8e3s4[tmp2_0 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_0 & 192) === 128)) {
                var c_6 = numberToChar(65533);
                var _unary__edvuaz_7 = length;
                length = _unary__edvuaz_7 + 1 | 0;
                chars[_unary__edvuaz_7] = c_6;
                tmp$ret$16 = 1;
                break $l$block_4;
              }
              var b2 = _this__u8e3s4[tmp2_0 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2 & 192) === 128)) {
                var c_7 = numberToChar(65533);
                var _unary__edvuaz_8 = length;
                length = _unary__edvuaz_8 + 1 | 0;
                chars[_unary__edvuaz_8] = c_7;
                tmp$ret$16 = 2;
                break $l$block_4;
              }
              var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
              if (codePoint_0 < 2048) {
                var c_8 = numberToChar(65533);
                var _unary__edvuaz_9 = length;
                length = _unary__edvuaz_9 + 1 | 0;
                chars[_unary__edvuaz_9] = c_8;
              } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
                var c_9 = numberToChar(65533);
                var _unary__edvuaz_10 = length;
                length = _unary__edvuaz_10 + 1 | 0;
                chars[_unary__edvuaz_10] = c_9;
              } else {
                var c_10 = numberToChar(codePoint_0);
                var _unary__edvuaz_11 = length;
                length = _unary__edvuaz_11 + 1 | 0;
                chars[_unary__edvuaz_11] = c_10;
              }
              tmp$ret$16 = 3;
            }
            index = tmp_0 + tmp$ret$16 | 0;
          } else {
            // Inline function 'okio.shr' call
            if (b0 >> 3 === -2) {
              var tmp_2 = index;
              var tmp2_1 = index;
              var tmp$ret$36;
              $l$block_10: {
                // Inline function 'okio.process4Utf8Bytes' call
                if (endIndex <= (tmp2_1 + 3 | 0)) {
                  if (!(65533 === 65533)) {
                    var c_11 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_12 = length;
                    length = _unary__edvuaz_12 + 1 | 0;
                    chars[_unary__edvuaz_12] = c_11;
                    var c_12 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_13 = length;
                    length = _unary__edvuaz_13 + 1 | 0;
                    chars[_unary__edvuaz_13] = c_12;
                  } else {
                    var c_13 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_14 = length;
                    length = _unary__edvuaz_14 + 1 | 0;
                    chars[_unary__edvuaz_14] = c_13;
                  }
                  var tmp_3;
                  if (endIndex <= (tmp2_1 + 1 | 0)) {
                    tmp_3 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_3 = !((_this__u8e3s4[tmp2_1 + 1 | 0] & 192) === 128);
                  }
                  if (tmp_3) {
                    tmp$ret$36 = 1;
                    break $l$block_10;
                  } else {
                    var tmp_4;
                    if (endIndex <= (tmp2_1 + 2 | 0)) {
                      tmp_4 = true;
                    } else {
                      // Inline function 'okio.isUtf8Continuation' call
                      // Inline function 'okio.and' call
                      tmp_4 = !((_this__u8e3s4[tmp2_1 + 2 | 0] & 192) === 128);
                    }
                    if (tmp_4) {
                      tmp$ret$36 = 2;
                      break $l$block_10;
                    } else {
                      tmp$ret$36 = 3;
                      break $l$block_10;
                    }
                  }
                }
                var b0_2 = _this__u8e3s4[tmp2_1];
                var b1_1 = _this__u8e3s4[tmp2_1 + 1 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b1_1 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_14 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_15 = length;
                    length = _unary__edvuaz_15 + 1 | 0;
                    chars[_unary__edvuaz_15] = c_14;
                    var c_15 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_16 = length;
                    length = _unary__edvuaz_16 + 1 | 0;
                    chars[_unary__edvuaz_16] = c_15;
                  } else {
                    var c_16 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_17 = length;
                    length = _unary__edvuaz_17 + 1 | 0;
                    chars[_unary__edvuaz_17] = c_16;
                  }
                  tmp$ret$36 = 1;
                  break $l$block_10;
                }
                var b2_0 = _this__u8e3s4[tmp2_1 + 2 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b2_0 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_17 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_18 = length;
                    length = _unary__edvuaz_18 + 1 | 0;
                    chars[_unary__edvuaz_18] = c_17;
                    var c_18 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_19 = length;
                    length = _unary__edvuaz_19 + 1 | 0;
                    chars[_unary__edvuaz_19] = c_18;
                  } else {
                    var c_19 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_20 = length;
                    length = _unary__edvuaz_20 + 1 | 0;
                    chars[_unary__edvuaz_20] = c_19;
                  }
                  tmp$ret$36 = 2;
                  break $l$block_10;
                }
                var b3 = _this__u8e3s4[tmp2_1 + 3 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b3 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_20 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_21 = length;
                    length = _unary__edvuaz_21 + 1 | 0;
                    chars[_unary__edvuaz_21] = c_20;
                    var c_21 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_22 = length;
                    length = _unary__edvuaz_22 + 1 | 0;
                    chars[_unary__edvuaz_22] = c_21;
                  } else {
                    var c_22 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_23 = length;
                    length = _unary__edvuaz_23 + 1 | 0;
                    chars[_unary__edvuaz_23] = c_22;
                  }
                  tmp$ret$36 = 3;
                  break $l$block_10;
                }
                var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
                if (codePoint_1 > 1114111) {
                  if (!(65533 === 65533)) {
                    var c_23 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_24 = length;
                    length = _unary__edvuaz_24 + 1 | 0;
                    chars[_unary__edvuaz_24] = c_23;
                    var c_24 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_25 = length;
                    length = _unary__edvuaz_25 + 1 | 0;
                    chars[_unary__edvuaz_25] = c_24;
                  } else {
                    var c_25 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_26 = length;
                    length = _unary__edvuaz_26 + 1 | 0;
                    chars[_unary__edvuaz_26] = c_25;
                  }
                } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                  if (!(65533 === 65533)) {
                    var c_26 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_27 = length;
                    length = _unary__edvuaz_27 + 1 | 0;
                    chars[_unary__edvuaz_27] = c_26;
                    var c_27 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_28 = length;
                    length = _unary__edvuaz_28 + 1 | 0;
                    chars[_unary__edvuaz_28] = c_27;
                  } else {
                    var c_28 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_29 = length;
                    length = _unary__edvuaz_29 + 1 | 0;
                    chars[_unary__edvuaz_29] = c_28;
                  }
                } else if (codePoint_1 < 65536) {
                  if (!(65533 === 65533)) {
                    var c_29 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_30 = length;
                    length = _unary__edvuaz_30 + 1 | 0;
                    chars[_unary__edvuaz_30] = c_29;
                    var c_30 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_31 = length;
                    length = _unary__edvuaz_31 + 1 | 0;
                    chars[_unary__edvuaz_31] = c_30;
                  } else {
                    var c_31 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_32 = length;
                    length = _unary__edvuaz_32 + 1 | 0;
                    chars[_unary__edvuaz_32] = c_31;
                  }
                } else {
                  if (!(codePoint_1 === 65533)) {
                    var c_32 = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_33 = length;
                    length = _unary__edvuaz_33 + 1 | 0;
                    chars[_unary__edvuaz_33] = c_32;
                    var c_33 = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                    var _unary__edvuaz_34 = length;
                    length = _unary__edvuaz_34 + 1 | 0;
                    chars[_unary__edvuaz_34] = c_33;
                  } else {
                    var c_34 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_35 = length;
                    length = _unary__edvuaz_35 + 1 | 0;
                    chars[_unary__edvuaz_35] = c_34;
                  }
                }
                tmp$ret$36 = 4;
              }
              index = tmp_2 + tmp$ret$36 | 0;
            } else {
              var c_35 = _Char___init__impl__6a9atx(65533);
              var _unary__edvuaz_36 = length;
              length = _unary__edvuaz_36 + 1 | 0;
              chars[_unary__edvuaz_36] = c_35;
              index = index + 1 | 0;
            }
          }
        }
      }
    }
    return concatToString(chars, 0, length);
  }
  function get_HEX_DIGIT_BYTES() {
    _init_properties_Buffer_kt__ndcom8();
    return HEX_DIGIT_BYTES;
  }
  var HEX_DIGIT_BYTES;
  function get_DigitCountToLargestValue() {
    _init_properties_Buffer_kt__ndcom8();
    return DigitCountToLargestValue;
  }
  var DigitCountToLargestValue;
  function commonIndexOf(_this__u8e3s4, bytes, fromIndex, toIndex, bytesOffset, byteCount) {
    toIndex = toIndex === VOID ? new Long(-1, 2147483647) : toIndex;
    bytesOffset = bytesOffset === VOID ? 0 : bytesOffset;
    byteCount = byteCount === VOID ? bytes.n1() : byteCount;
    _init_properties_Buffer_kt__ndcom8();
    checkOffsetAndCount(fromInt(bytes.n1()), fromInt(bytesOffset), fromInt(byteCount));
    // Inline function 'kotlin.require' call
    if (!(byteCount > 0)) {
      var message = 'byteCount == 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(compare(fromIndex, new Long(0, 0)) >= 0)) {
      var message_0 = 'fromIndex < 0: ' + fromIndex.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!(compare(fromIndex, toIndex) <= 0)) {
      var message_1 = 'fromIndex > toIndex: ' + fromIndex.toString() + ' > ' + toIndex.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
    var fromIndex_0 = fromIndex;
    var toIndex_0 = toIndex;
    if (compare(toIndex_0, _this__u8e3s4.svp_1) > 0)
      toIndex_0 = _this__u8e3s4.svp_1;
    if (equalsLong(fromIndex_0, toIndex_0))
      return new Long(-1, -1);
    var tmp2 = fromIndex_0;
    $l$block_1: {
      // Inline function 'okio.internal.seek' call
      var tmp0_elvis_lhs = _this__u8e3s4.rvp_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var offset = new Long(-1, -1);
        var tmp_0;
        if (null == null) {
          return new Long(-1, -1);
        } else {
          tmp_0 = null;
        }
        var s = tmp_0;
        var offset_0 = offset;
        var targetByteArray = bytes.nvq();
        var b0 = targetByteArray[bytesOffset];
        var tmp0 = toIndex_0;
        // Inline function 'kotlin.Long.minus' call
        var this_0 = _this__u8e3s4.svp_1;
        var tmp$ret$8 = subtract(this_0, fromInt(byteCount));
        // Inline function 'kotlin.comparisons.minOf' call
        var b = add(tmp$ret$8, new Long(1, 0));
        var resultLimit = compare(tmp0, b) <= 0 ? tmp0 : b;
        while (compare(offset_0, resultLimit) < 0) {
          var data = s.tvp_1;
          var tmp0_0 = s.vvp_1;
          // Inline function 'okio.minOf' call
          var b_0 = subtract(add(numberToLong(s.uvp_1), resultLimit), offset_0);
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(tmp0_0);
          var tmp$ret$10 = compare(a, b_0) <= 0 ? a : b_0;
          var segmentLimit = convertToInt(tmp$ret$10);
          var inductionVariable = convertToInt(subtract(add(numberToLong(s.uvp_1), fromIndex_0), offset_0));
          if (inductionVariable < segmentLimit)
            do {
              var pos = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (data[pos] === b0 && rangeEquals(s, pos + 1 | 0, targetByteArray, bytesOffset + 1 | 0, byteCount)) {
                return add(numberToLong(pos - s.uvp_1 | 0), offset_0);
              }
            }
             while (inductionVariable < segmentLimit);
          offset_0 = add(offset_0, fromInt(s.vvp_1 - s.uvp_1 | 0));
          fromIndex_0 = offset_0;
          s = ensureNotNull(s.yvp_1);
        }
        return new Long(-1, -1);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s_0 = tmp;
      if (compare(subtract(_this__u8e3s4.svp_1, tmp2), tmp2) < 0) {
        var offset_1 = _this__u8e3s4.svp_1;
        while (compare(offset_1, tmp2) > 0) {
          s_0 = ensureNotNull(s_0.zvp_1);
          offset_1 = subtract(offset_1, fromInt(s_0.vvp_1 - s_0.uvp_1 | 0));
        }
        var tmp0_1 = s_0;
        var offset_2 = offset_1;
        var tmp_1;
        if (tmp0_1 == null) {
          return new Long(-1, -1);
        } else {
          tmp_1 = tmp0_1;
        }
        var s_1 = tmp_1;
        var offset_3 = offset_2;
        var targetByteArray_0 = bytes.nvq();
        var b0_0 = targetByteArray_0[bytesOffset];
        var tmp0_2 = toIndex_0;
        // Inline function 'kotlin.Long.minus' call
        var this_1 = _this__u8e3s4.svp_1;
        var tmp$ret$13 = subtract(this_1, fromInt(byteCount));
        // Inline function 'kotlin.comparisons.minOf' call
        var b_1 = add(tmp$ret$13, new Long(1, 0));
        var resultLimit_0 = compare(tmp0_2, b_1) <= 0 ? tmp0_2 : b_1;
        while (compare(offset_3, resultLimit_0) < 0) {
          var data_0 = s_1.tvp_1;
          var tmp0_3 = s_1.vvp_1;
          // Inline function 'okio.minOf' call
          var b_2 = subtract(add(numberToLong(s_1.uvp_1), resultLimit_0), offset_3);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = fromInt(tmp0_3);
          var tmp$ret$15 = compare(a_0, b_2) <= 0 ? a_0 : b_2;
          var segmentLimit_0 = convertToInt(tmp$ret$15);
          var inductionVariable_0 = convertToInt(subtract(add(numberToLong(s_1.uvp_1), fromIndex_0), offset_3));
          if (inductionVariable_0 < segmentLimit_0)
            do {
              var pos_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (data_0[pos_0] === b0_0 && rangeEquals(s_1, pos_0 + 1 | 0, targetByteArray_0, bytesOffset + 1 | 0, byteCount)) {
                return add(numberToLong(pos_0 - s_1.uvp_1 | 0), offset_3);
              }
            }
             while (inductionVariable_0 < segmentLimit_0);
          offset_3 = add(offset_3, fromInt(s_1.vvp_1 - s_1.uvp_1 | 0));
          fromIndex_0 = offset_3;
          s_1 = ensureNotNull(s_1.yvp_1);
        }
        return new Long(-1, -1);
      } else {
        var offset_4 = new Long(0, 0);
        $l$loop: while (true) {
          var tmp0_4 = offset_4;
          // Inline function 'kotlin.Long.plus' call
          var other = s_0.vvp_1 - s_0.uvp_1 | 0;
          var nextOffset = add(tmp0_4, fromInt(other));
          if (compare(nextOffset, tmp2) > 0)
            break $l$loop;
          s_0 = ensureNotNull(s_0.yvp_1);
          offset_4 = nextOffset;
        }
        var tmp0_5 = s_0;
        var offset_5 = offset_4;
        var tmp_2;
        if (tmp0_5 == null) {
          return new Long(-1, -1);
        } else {
          tmp_2 = tmp0_5;
        }
        var s_2 = tmp_2;
        var offset_6 = offset_5;
        var targetByteArray_1 = bytes.nvq();
        var b0_1 = targetByteArray_1[bytesOffset];
        var tmp0_6 = toIndex_0;
        // Inline function 'kotlin.Long.minus' call
        var this_2 = _this__u8e3s4.svp_1;
        var tmp$ret$19 = subtract(this_2, fromInt(byteCount));
        // Inline function 'kotlin.comparisons.minOf' call
        var b_3 = add(tmp$ret$19, new Long(1, 0));
        var resultLimit_1 = compare(tmp0_6, b_3) <= 0 ? tmp0_6 : b_3;
        while (compare(offset_6, resultLimit_1) < 0) {
          var data_1 = s_2.tvp_1;
          var tmp0_7 = s_2.vvp_1;
          // Inline function 'okio.minOf' call
          var b_4 = subtract(add(numberToLong(s_2.uvp_1), resultLimit_1), offset_6);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_1 = fromInt(tmp0_7);
          var tmp$ret$21 = compare(a_1, b_4) <= 0 ? a_1 : b_4;
          var segmentLimit_1 = convertToInt(tmp$ret$21);
          var inductionVariable_1 = convertToInt(subtract(add(numberToLong(s_2.uvp_1), fromIndex_0), offset_6));
          if (inductionVariable_1 < segmentLimit_1)
            do {
              var pos_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if (data_1[pos_1] === b0_1 && rangeEquals(s_2, pos_1 + 1 | 0, targetByteArray_1, bytesOffset + 1 | 0, byteCount)) {
                return add(numberToLong(pos_1 - s_2.uvp_1 | 0), offset_6);
              }
            }
             while (inductionVariable_1 < segmentLimit_1);
          offset_6 = add(offset_6, fromInt(s_2.vvp_1 - s_2.uvp_1 | 0));
          fromIndex_0 = offset_6;
          s_2 = ensureNotNull(s_2.yvp_1);
        }
        return new Long(-1, -1);
      }
    }
  }
  function countDigitsIn(v) {
    _init_properties_Buffer_kt__ndcom8();
    var guess = imul(64 - countLeadingZeroBits(v) | 0, 10) >>> 5 | 0;
    return guess + (compare(v, get_DigitCountToLargestValue()[guess]) > 0 ? 1 : 0) | 0;
  }
  function rangeEquals(segment, segmentPos, bytes, bytesOffset, bytesLimit) {
    _init_properties_Buffer_kt__ndcom8();
    var segment_0 = segment;
    var segmentPos_0 = segmentPos;
    var segmentLimit = segment_0.vvp_1;
    var data = segment_0.tvp_1;
    var i = bytesOffset;
    while (i < bytesLimit) {
      if (segmentPos_0 === segmentLimit) {
        segment_0 = ensureNotNull(segment_0.yvp_1);
        data = segment_0.tvp_1;
        segmentPos_0 = segment_0.uvp_1;
        segmentLimit = segment_0.vvp_1;
      }
      if (!(data[segmentPos_0] === bytes[i])) {
        return false;
      }
      segmentPos_0 = segmentPos_0 + 1 | 0;
      i = i + 1 | 0;
    }
    return true;
  }
  function access$countDigitsIn$tBufferKt(v) {
    return countDigitsIn(v);
  }
  var properties_initialized_Buffer_kt_xv4xxe;
  function _init_properties_Buffer_kt__ndcom8() {
    if (!properties_initialized_Buffer_kt_xv4xxe) {
      properties_initialized_Buffer_kt_xv4xxe = true;
      HEX_DIGIT_BYTES = asUtf8ToByteArray('0123456789abcdef');
      // Inline function 'kotlin.longArrayOf' call
      DigitCountToLargestValue = longArrayOf([new Long(-1, -1), new Long(9, 0), new Long(99, 0), new Long(999, 0), new Long(9999, 0), new Long(99999, 0), new Long(999999, 0), new Long(9999999, 0), new Long(99999999, 0), new Long(999999999, 0), new Long(1410065407, 2), new Long(1215752191, 23), new Long(-727379969, 232), new Long(1316134911, 2328), new Long(276447231, 23283), new Long(-1530494977, 232830), new Long(1874919423, 2328306), new Long(1569325055, 23283064), new Long(-1486618625, 232830643), new Long(-1, 2147483647)]);
    }
  }
  function get_HEX_DIGIT_CHARS() {
    _init_properties_ByteString_kt__sqjq7b();
    return HEX_DIGIT_CHARS;
  }
  var HEX_DIGIT_CHARS;
  function commonWrite(_this__u8e3s4, buffer, offset, byteCount) {
    _init_properties_ByteString_kt__sqjq7b();
    buffer.ovq(_this__u8e3s4.kvq_1, offset, byteCount);
  }
  function codePointIndexToCharIndex(s, codePointCount) {
    _init_properties_ByteString_kt__sqjq7b();
    var charCount = 0;
    var j = 0;
    // Inline function 'okio.processUtf8CodePoints' call
    var endIndex = s.length;
    var index = 0;
    while (index < endIndex) {
      var b0 = s[index];
      if (b0 >= 0) {
        var _unary__edvuaz = j;
        j = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === codePointCount) {
          return charCount;
        }
        var tmp;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(10);
        if (!(b0 === Char__toInt_impl_vasixd(this_0))) {
          // Inline function 'kotlin.code' call
          var this_1 = _Char___init__impl__6a9atx(13);
          tmp_1 = !(b0 === Char__toInt_impl_vasixd(this_1));
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          // Inline function 'okio.isIsoControl' call
          tmp_0 = (0 <= b0 ? b0 <= 31 : false) || (127 <= b0 ? b0 <= 159 : false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = true;
        } else {
          tmp = b0 === 65533;
        }
        if (tmp) {
          return -1;
        }
        charCount = charCount + (b0 < 65536 ? 1 : 2) | 0;
        index = index + 1 | 0;
        while (index < endIndex && s[index] >= 0) {
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          var c = s[_unary__edvuaz_0];
          var _unary__edvuaz_1 = j;
          j = _unary__edvuaz_1 + 1 | 0;
          if (_unary__edvuaz_1 === codePointCount) {
            return charCount;
          }
          var tmp_2;
          var tmp_3;
          var tmp_4;
          // Inline function 'kotlin.code' call
          var this_2 = _Char___init__impl__6a9atx(10);
          if (!(c === Char__toInt_impl_vasixd(this_2))) {
            // Inline function 'kotlin.code' call
            var this_3 = _Char___init__impl__6a9atx(13);
            tmp_4 = !(c === Char__toInt_impl_vasixd(this_3));
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            // Inline function 'okio.isIsoControl' call
            tmp_3 = (0 <= c ? c <= 31 : false) || (127 <= c ? c <= 159 : false);
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp_2 = true;
          } else {
            tmp_2 = c === 65533;
          }
          if (tmp_2) {
            return -1;
          }
          charCount = charCount + (c < 65536 ? 1 : 2) | 0;
        }
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 5 === -2) {
          var tmp_5 = index;
          var tmp2 = index;
          var tmp$ret$10;
          $l$block_0: {
            // Inline function 'okio.process2Utf8Bytes' call
            if (endIndex <= (tmp2 + 1 | 0)) {
              var _unary__edvuaz_2 = j;
              j = _unary__edvuaz_2 + 1 | 0;
              if (_unary__edvuaz_2 === codePointCount) {
                return charCount;
              }
              var tmp_6;
              var tmp_7;
              var tmp_8;
              // Inline function 'kotlin.code' call
              var this_4 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_4))) {
                // Inline function 'kotlin.code' call
                var this_5 = _Char___init__impl__6a9atx(13);
                tmp_8 = !(65533 === Char__toInt_impl_vasixd(this_5));
              } else {
                tmp_8 = false;
              }
              if (tmp_8) {
                // Inline function 'okio.isIsoControl' call
                tmp_7 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_7 = false;
              }
              if (tmp_7) {
                tmp_6 = true;
              } else {
                tmp_6 = 65533 === 65533;
              }
              if (tmp_6) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$10 = 1;
              break $l$block_0;
            }
            var b0_0 = s[tmp2];
            var b1 = s[tmp2 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1 & 192) === 128)) {
              var _unary__edvuaz_3 = j;
              j = _unary__edvuaz_3 + 1 | 0;
              if (_unary__edvuaz_3 === codePointCount) {
                return charCount;
              }
              var tmp_9;
              var tmp_10;
              var tmp_11;
              // Inline function 'kotlin.code' call
              var this_6 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_6))) {
                // Inline function 'kotlin.code' call
                var this_7 = _Char___init__impl__6a9atx(13);
                tmp_11 = !(65533 === Char__toInt_impl_vasixd(this_7));
              } else {
                tmp_11 = false;
              }
              if (tmp_11) {
                // Inline function 'okio.isIsoControl' call
                tmp_10 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_10 = false;
              }
              if (tmp_10) {
                tmp_9 = true;
              } else {
                tmp_9 = 65533 === 65533;
              }
              if (tmp_9) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$10 = 1;
              break $l$block_0;
            }
            var codePoint = 3968 ^ b1 ^ b0_0 << 6;
            if (codePoint < 128) {
              var _unary__edvuaz_4 = j;
              j = _unary__edvuaz_4 + 1 | 0;
              if (_unary__edvuaz_4 === codePointCount) {
                return charCount;
              }
              var tmp_12;
              var tmp_13;
              var tmp_14;
              // Inline function 'kotlin.code' call
              var this_8 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_8))) {
                // Inline function 'kotlin.code' call
                var this_9 = _Char___init__impl__6a9atx(13);
                tmp_14 = !(65533 === Char__toInt_impl_vasixd(this_9));
              } else {
                tmp_14 = false;
              }
              if (tmp_14) {
                // Inline function 'okio.isIsoControl' call
                tmp_13 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_13 = false;
              }
              if (tmp_13) {
                tmp_12 = true;
              } else {
                tmp_12 = 65533 === 65533;
              }
              if (tmp_12) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            } else {
              var _unary__edvuaz_5 = j;
              j = _unary__edvuaz_5 + 1 | 0;
              if (_unary__edvuaz_5 === codePointCount) {
                return charCount;
              }
              var tmp_15;
              var tmp_16;
              var tmp_17;
              // Inline function 'kotlin.code' call
              var this_10 = _Char___init__impl__6a9atx(10);
              if (!(codePoint === Char__toInt_impl_vasixd(this_10))) {
                // Inline function 'kotlin.code' call
                var this_11 = _Char___init__impl__6a9atx(13);
                tmp_17 = !(codePoint === Char__toInt_impl_vasixd(this_11));
              } else {
                tmp_17 = false;
              }
              if (tmp_17) {
                // Inline function 'okio.isIsoControl' call
                tmp_16 = (0 <= codePoint ? codePoint <= 31 : false) || (127 <= codePoint ? codePoint <= 159 : false);
              } else {
                tmp_16 = false;
              }
              if (tmp_16) {
                tmp_15 = true;
              } else {
                tmp_15 = codePoint === 65533;
              }
              if (tmp_15) {
                return -1;
              }
              charCount = charCount + (codePoint < 65536 ? 1 : 2) | 0;
            }
            tmp$ret$10 = 2;
          }
          index = tmp_5 + tmp$ret$10 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 4 === -2) {
            var tmp_18 = index;
            var tmp2_0 = index;
            var tmp$ret$34;
            $l$block_4: {
              // Inline function 'okio.process3Utf8Bytes' call
              if (endIndex <= (tmp2_0 + 2 | 0)) {
                var _unary__edvuaz_6 = j;
                j = _unary__edvuaz_6 + 1 | 0;
                if (_unary__edvuaz_6 === codePointCount) {
                  return charCount;
                }
                var tmp_19;
                var tmp_20;
                var tmp_21;
                // Inline function 'kotlin.code' call
                var this_12 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_12))) {
                  // Inline function 'kotlin.code' call
                  var this_13 = _Char___init__impl__6a9atx(13);
                  tmp_21 = !(65533 === Char__toInt_impl_vasixd(this_13));
                } else {
                  tmp_21 = false;
                }
                if (tmp_21) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_20 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_20 = false;
                }
                if (tmp_20) {
                  tmp_19 = true;
                } else {
                  tmp_19 = 65533 === 65533;
                }
                if (tmp_19) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                var tmp_22;
                if (endIndex <= (tmp2_0 + 1 | 0)) {
                  tmp_22 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_22 = !((s[tmp2_0 + 1 | 0] & 192) === 128);
                }
                if (tmp_22) {
                  tmp$ret$34 = 1;
                  break $l$block_4;
                } else {
                  tmp$ret$34 = 2;
                  break $l$block_4;
                }
              }
              var b0_1 = s[tmp2_0];
              var b1_0 = s[tmp2_0 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_0 & 192) === 128)) {
                var _unary__edvuaz_7 = j;
                j = _unary__edvuaz_7 + 1 | 0;
                if (_unary__edvuaz_7 === codePointCount) {
                  return charCount;
                }
                var tmp_23;
                var tmp_24;
                var tmp_25;
                // Inline function 'kotlin.code' call
                var this_14 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_14))) {
                  // Inline function 'kotlin.code' call
                  var this_15 = _Char___init__impl__6a9atx(13);
                  tmp_25 = !(65533 === Char__toInt_impl_vasixd(this_15));
                } else {
                  tmp_25 = false;
                }
                if (tmp_25) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_24 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_24 = false;
                }
                if (tmp_24) {
                  tmp_23 = true;
                } else {
                  tmp_23 = 65533 === 65533;
                }
                if (tmp_23) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$34 = 1;
                break $l$block_4;
              }
              var b2 = s[tmp2_0 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2 & 192) === 128)) {
                var _unary__edvuaz_8 = j;
                j = _unary__edvuaz_8 + 1 | 0;
                if (_unary__edvuaz_8 === codePointCount) {
                  return charCount;
                }
                var tmp_26;
                var tmp_27;
                var tmp_28;
                // Inline function 'kotlin.code' call
                var this_16 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_16))) {
                  // Inline function 'kotlin.code' call
                  var this_17 = _Char___init__impl__6a9atx(13);
                  tmp_28 = !(65533 === Char__toInt_impl_vasixd(this_17));
                } else {
                  tmp_28 = false;
                }
                if (tmp_28) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_27 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_27 = false;
                }
                if (tmp_27) {
                  tmp_26 = true;
                } else {
                  tmp_26 = 65533 === 65533;
                }
                if (tmp_26) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$34 = 2;
                break $l$block_4;
              }
              var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
              if (codePoint_0 < 2048) {
                var _unary__edvuaz_9 = j;
                j = _unary__edvuaz_9 + 1 | 0;
                if (_unary__edvuaz_9 === codePointCount) {
                  return charCount;
                }
                var tmp_29;
                var tmp_30;
                var tmp_31;
                // Inline function 'kotlin.code' call
                var this_18 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_18))) {
                  // Inline function 'kotlin.code' call
                  var this_19 = _Char___init__impl__6a9atx(13);
                  tmp_31 = !(65533 === Char__toInt_impl_vasixd(this_19));
                } else {
                  tmp_31 = false;
                }
                if (tmp_31) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_30 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_30 = false;
                }
                if (tmp_30) {
                  tmp_29 = true;
                } else {
                  tmp_29 = 65533 === 65533;
                }
                if (tmp_29) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
                var _unary__edvuaz_10 = j;
                j = _unary__edvuaz_10 + 1 | 0;
                if (_unary__edvuaz_10 === codePointCount) {
                  return charCount;
                }
                var tmp_32;
                var tmp_33;
                var tmp_34;
                // Inline function 'kotlin.code' call
                var this_20 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_20))) {
                  // Inline function 'kotlin.code' call
                  var this_21 = _Char___init__impl__6a9atx(13);
                  tmp_34 = !(65533 === Char__toInt_impl_vasixd(this_21));
                } else {
                  tmp_34 = false;
                }
                if (tmp_34) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_33 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_33 = false;
                }
                if (tmp_33) {
                  tmp_32 = true;
                } else {
                  tmp_32 = 65533 === 65533;
                }
                if (tmp_32) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else {
                var _unary__edvuaz_11 = j;
                j = _unary__edvuaz_11 + 1 | 0;
                if (_unary__edvuaz_11 === codePointCount) {
                  return charCount;
                }
                var tmp_35;
                var tmp_36;
                var tmp_37;
                // Inline function 'kotlin.code' call
                var this_22 = _Char___init__impl__6a9atx(10);
                if (!(codePoint_0 === Char__toInt_impl_vasixd(this_22))) {
                  // Inline function 'kotlin.code' call
                  var this_23 = _Char___init__impl__6a9atx(13);
                  tmp_37 = !(codePoint_0 === Char__toInt_impl_vasixd(this_23));
                } else {
                  tmp_37 = false;
                }
                if (tmp_37) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_36 = (0 <= codePoint_0 ? codePoint_0 <= 31 : false) || (127 <= codePoint_0 ? codePoint_0 <= 159 : false);
                } else {
                  tmp_36 = false;
                }
                if (tmp_36) {
                  tmp_35 = true;
                } else {
                  tmp_35 = codePoint_0 === 65533;
                }
                if (tmp_35) {
                  return -1;
                }
                charCount = charCount + (codePoint_0 < 65536 ? 1 : 2) | 0;
              }
              tmp$ret$34 = 3;
            }
            index = tmp_18 + tmp$ret$34 | 0;
          } else {
            // Inline function 'okio.shr' call
            if (b0 >> 3 === -2) {
              var tmp_38 = index;
              var tmp2_1 = index;
              var tmp$ret$72;
              $l$block_10: {
                // Inline function 'okio.process4Utf8Bytes' call
                if (endIndex <= (tmp2_1 + 3 | 0)) {
                  var _unary__edvuaz_12 = j;
                  j = _unary__edvuaz_12 + 1 | 0;
                  if (_unary__edvuaz_12 === codePointCount) {
                    return charCount;
                  }
                  var tmp_39;
                  var tmp_40;
                  var tmp_41;
                  // Inline function 'kotlin.code' call
                  var this_24 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_24))) {
                    // Inline function 'kotlin.code' call
                    var this_25 = _Char___init__impl__6a9atx(13);
                    tmp_41 = !(65533 === Char__toInt_impl_vasixd(this_25));
                  } else {
                    tmp_41 = false;
                  }
                  if (tmp_41) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_40 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_40 = false;
                  }
                  if (tmp_40) {
                    tmp_39 = true;
                  } else {
                    tmp_39 = 65533 === 65533;
                  }
                  if (tmp_39) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                  var tmp_42;
                  if (endIndex <= (tmp2_1 + 1 | 0)) {
                    tmp_42 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_42 = !((s[tmp2_1 + 1 | 0] & 192) === 128);
                  }
                  if (tmp_42) {
                    tmp$ret$72 = 1;
                    break $l$block_10;
                  } else {
                    var tmp_43;
                    if (endIndex <= (tmp2_1 + 2 | 0)) {
                      tmp_43 = true;
                    } else {
                      // Inline function 'okio.isUtf8Continuation' call
                      // Inline function 'okio.and' call
                      tmp_43 = !((s[tmp2_1 + 2 | 0] & 192) === 128);
                    }
                    if (tmp_43) {
                      tmp$ret$72 = 2;
                      break $l$block_10;
                    } else {
                      tmp$ret$72 = 3;
                      break $l$block_10;
                    }
                  }
                }
                var b0_2 = s[tmp2_1];
                var b1_1 = s[tmp2_1 + 1 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b1_1 & 192) === 128)) {
                  var _unary__edvuaz_13 = j;
                  j = _unary__edvuaz_13 + 1 | 0;
                  if (_unary__edvuaz_13 === codePointCount) {
                    return charCount;
                  }
                  var tmp_44;
                  var tmp_45;
                  var tmp_46;
                  // Inline function 'kotlin.code' call
                  var this_26 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_26))) {
                    // Inline function 'kotlin.code' call
                    var this_27 = _Char___init__impl__6a9atx(13);
                    tmp_46 = !(65533 === Char__toInt_impl_vasixd(this_27));
                  } else {
                    tmp_46 = false;
                  }
                  if (tmp_46) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_45 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_45 = false;
                  }
                  if (tmp_45) {
                    tmp_44 = true;
                  } else {
                    tmp_44 = 65533 === 65533;
                  }
                  if (tmp_44) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                  tmp$ret$72 = 1;
                  break $l$block_10;
                }
                var b2_0 = s[tmp2_1 + 2 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b2_0 & 192) === 128)) {
                  var _unary__edvuaz_14 = j;
                  j = _unary__edvuaz_14 + 1 | 0;
                  if (_unary__edvuaz_14 === codePointCount) {
                    return charCount;
                  }
                  var tmp_47;
                  var tmp_48;
                  var tmp_49;
                  // Inline function 'kotlin.code' call
                  var this_28 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_28))) {
                    // Inline function 'kotlin.code' call
                    var this_29 = _Char___init__impl__6a9atx(13);
                    tmp_49 = !(65533 === Char__toInt_impl_vasixd(this_29));
                  } else {
                    tmp_49 = false;
                  }
                  if (tmp_49) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_48 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_48 = false;
                  }
                  if (tmp_48) {
                    tmp_47 = true;
                  } else {
                    tmp_47 = 65533 === 65533;
                  }
                  if (tmp_47) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                  tmp$ret$72 = 2;
                  break $l$block_10;
                }
                var b3 = s[tmp2_1 + 3 | 0];
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                if (!((b3 & 192) === 128)) {
                  var _unary__edvuaz_15 = j;
                  j = _unary__edvuaz_15 + 1 | 0;
                  if (_unary__edvuaz_15 === codePointCount) {
                    return charCount;
                  }
                  var tmp_50;
                  var tmp_51;
                  var tmp_52;
                  // Inline function 'kotlin.code' call
                  var this_30 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_30))) {
                    // Inline function 'kotlin.code' call
                    var this_31 = _Char___init__impl__6a9atx(13);
                    tmp_52 = !(65533 === Char__toInt_impl_vasixd(this_31));
                  } else {
                    tmp_52 = false;
                  }
                  if (tmp_52) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_51 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_51 = false;
                  }
                  if (tmp_51) {
                    tmp_50 = true;
                  } else {
                    tmp_50 = 65533 === 65533;
                  }
                  if (tmp_50) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                  tmp$ret$72 = 3;
                  break $l$block_10;
                }
                var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
                if (codePoint_1 > 1114111) {
                  var _unary__edvuaz_16 = j;
                  j = _unary__edvuaz_16 + 1 | 0;
                  if (_unary__edvuaz_16 === codePointCount) {
                    return charCount;
                  }
                  var tmp_53;
                  var tmp_54;
                  var tmp_55;
                  // Inline function 'kotlin.code' call
                  var this_32 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_32))) {
                    // Inline function 'kotlin.code' call
                    var this_33 = _Char___init__impl__6a9atx(13);
                    tmp_55 = !(65533 === Char__toInt_impl_vasixd(this_33));
                  } else {
                    tmp_55 = false;
                  }
                  if (tmp_55) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_54 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_54 = false;
                  }
                  if (tmp_54) {
                    tmp_53 = true;
                  } else {
                    tmp_53 = 65533 === 65533;
                  }
                  if (tmp_53) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                  var _unary__edvuaz_17 = j;
                  j = _unary__edvuaz_17 + 1 | 0;
                  if (_unary__edvuaz_17 === codePointCount) {
                    return charCount;
                  }
                  var tmp_56;
                  var tmp_57;
                  var tmp_58;
                  // Inline function 'kotlin.code' call
                  var this_34 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_34))) {
                    // Inline function 'kotlin.code' call
                    var this_35 = _Char___init__impl__6a9atx(13);
                    tmp_58 = !(65533 === Char__toInt_impl_vasixd(this_35));
                  } else {
                    tmp_58 = false;
                  }
                  if (tmp_58) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_57 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_57 = false;
                  }
                  if (tmp_57) {
                    tmp_56 = true;
                  } else {
                    tmp_56 = 65533 === 65533;
                  }
                  if (tmp_56) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                } else if (codePoint_1 < 65536) {
                  var _unary__edvuaz_18 = j;
                  j = _unary__edvuaz_18 + 1 | 0;
                  if (_unary__edvuaz_18 === codePointCount) {
                    return charCount;
                  }
                  var tmp_59;
                  var tmp_60;
                  var tmp_61;
                  // Inline function 'kotlin.code' call
                  var this_36 = _Char___init__impl__6a9atx(10);
                  if (!(65533 === Char__toInt_impl_vasixd(this_36))) {
                    // Inline function 'kotlin.code' call
                    var this_37 = _Char___init__impl__6a9atx(13);
                    tmp_61 = !(65533 === Char__toInt_impl_vasixd(this_37));
                  } else {
                    tmp_61 = false;
                  }
                  if (tmp_61) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_60 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                  } else {
                    tmp_60 = false;
                  }
                  if (tmp_60) {
                    tmp_59 = true;
                  } else {
                    tmp_59 = 65533 === 65533;
                  }
                  if (tmp_59) {
                    return -1;
                  }
                  charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                } else {
                  var _unary__edvuaz_19 = j;
                  j = _unary__edvuaz_19 + 1 | 0;
                  if (_unary__edvuaz_19 === codePointCount) {
                    return charCount;
                  }
                  var tmp_62;
                  var tmp_63;
                  var tmp_64;
                  // Inline function 'kotlin.code' call
                  var this_38 = _Char___init__impl__6a9atx(10);
                  if (!(codePoint_1 === Char__toInt_impl_vasixd(this_38))) {
                    // Inline function 'kotlin.code' call
                    var this_39 = _Char___init__impl__6a9atx(13);
                    tmp_64 = !(codePoint_1 === Char__toInt_impl_vasixd(this_39));
                  } else {
                    tmp_64 = false;
                  }
                  if (tmp_64) {
                    // Inline function 'okio.isIsoControl' call
                    tmp_63 = (0 <= codePoint_1 ? codePoint_1 <= 31 : false) || (127 <= codePoint_1 ? codePoint_1 <= 159 : false);
                  } else {
                    tmp_63 = false;
                  }
                  if (tmp_63) {
                    tmp_62 = true;
                  } else {
                    tmp_62 = codePoint_1 === 65533;
                  }
                  if (tmp_62) {
                    return -1;
                  }
                  charCount = charCount + (codePoint_1 < 65536 ? 1 : 2) | 0;
                }
                tmp$ret$72 = 4;
              }
              index = tmp_38 + tmp$ret$72 | 0;
            } else {
              var _unary__edvuaz_20 = j;
              j = _unary__edvuaz_20 + 1 | 0;
              if (_unary__edvuaz_20 === codePointCount) {
                return charCount;
              }
              var tmp_65;
              var tmp_66;
              var tmp_67;
              // Inline function 'kotlin.code' call
              var this_40 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_40))) {
                // Inline function 'kotlin.code' call
                var this_41 = _Char___init__impl__6a9atx(13);
                tmp_67 = !(65533 === Char__toInt_impl_vasixd(this_41));
              } else {
                tmp_67 = false;
              }
              if (tmp_67) {
                // Inline function 'okio.isIsoControl' call
                tmp_66 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_66 = false;
              }
              if (tmp_66) {
                tmp_65 = true;
              } else {
                tmp_65 = 65533 === 65533;
              }
              if (tmp_65) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              index = index + 1 | 0;
            }
          }
        }
      }
    }
    return charCount;
  }
  function access$codePointIndexToCharIndex$tByteStringKt(s, codePointCount) {
    return codePointIndexToCharIndex(s, codePointCount);
  }
  var properties_initialized_ByteString_kt_8ybv8b;
  function _init_properties_ByteString_kt__sqjq7b() {
    if (!properties_initialized_ByteString_kt_8ybv8b) {
      properties_initialized_ByteString_kt_8ybv8b = true;
      // Inline function 'kotlin.charArrayOf' call
      HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
    }
  }
  function commonExists(_this__u8e3s4, path) {
    return !(_this__u8e3s4.dvp(path) == null);
  }
  function commonCreateDirectories(_this__u8e3s4, dir, mustCreate) {
    var directories = ArrayDeque_init_$Create$();
    var path = dir;
    while (!(path == null) && !_this__u8e3s4.nvp(path)) {
      directories.zg(path);
      path = path.k1a();
    }
    if (mustCreate && directories.r())
      throw IOException_init_$Create$(dir.toString() + ' already exists.');
    var _iterator__ex2g4s = directories.t();
    while (_iterator__ex2g4s.u()) {
      var toCreate = _iterator__ex2g4s.v();
      _this__u8e3s4.jvp(toCreate);
    }
  }
  function get_SLASH() {
    _init_properties_Path_kt__cy3pvf();
    return SLASH;
  }
  var SLASH;
  function get_BACKSLASH() {
    _init_properties_Path_kt__cy3pvf();
    return BACKSLASH;
  }
  var BACKSLASH;
  function get_ANY_SLASH() {
    _init_properties_Path_kt__cy3pvf();
    return ANY_SLASH;
  }
  var ANY_SLASH;
  function get_DOT() {
    _init_properties_Path_kt__cy3pvf();
    return DOT;
  }
  var DOT;
  function get_DOT_DOT() {
    _init_properties_Path_kt__cy3pvf();
    return DOT_DOT;
  }
  var DOT_DOT;
  function commonResolve(_this__u8e3s4, child, normalize) {
    _init_properties_Path_kt__cy3pvf();
    var tmp;
    if (child.rvq()) {
      tmp = true;
    } else {
      var tmp_0 = child.qvq();
      tmp = !((tmp_0 == null ? null : new Char(tmp_0)) == null);
    }
    if (tmp)
      return child;
    var tmp0_elvis_lhs = get_slash(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_slash(child) : tmp0_elvis_lhs;
    var slash = tmp1_elvis_lhs == null ? toSlash(Companion_getInstance_3().svq_1) : tmp1_elvis_lhs;
    var buffer = new Buffer();
    buffer.tvq(_this__u8e3s4.pvq_1);
    if (compare(buffer.svp_1, new Long(0, 0)) > 0) {
      buffer.tvq(slash);
    }
    buffer.tvq(child.pvq_1);
    return toPath(buffer, normalize);
  }
  function commonToPath(_this__u8e3s4, normalize) {
    _init_properties_Path_kt__cy3pvf();
    return toPath((new Buffer()).uvq(_this__u8e3s4), normalize);
  }
  function rootLength(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    if (_this__u8e3s4.pvq_1.n1() === 0)
      return -1;
    var tmp = _this__u8e3s4.pvq_1.l1(0);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(47);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    if (tmp === toByte(tmp$ret$0))
      return 1;
    var tmp_0 = _this__u8e3s4.pvq_1.l1(0);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(92);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    if (tmp_0 === toByte(tmp$ret$1)) {
      var tmp_1;
      if (_this__u8e3s4.pvq_1.n1() > 2) {
        var tmp_2 = _this__u8e3s4.pvq_1.l1(1);
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(92);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
        tmp_1 = tmp_2 === toByte(tmp$ret$2);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var uncRootEnd = _this__u8e3s4.pvq_1.vvq(get_BACKSLASH(), 2);
        if (uncRootEnd === -1)
          uncRootEnd = _this__u8e3s4.pvq_1.n1();
        return uncRootEnd;
      }
      return 1;
    }
    var tmp_3;
    var tmp_4;
    if (_this__u8e3s4.pvq_1.n1() > 2) {
      var tmp_5 = _this__u8e3s4.pvq_1.l1(1);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(58);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      tmp_4 = tmp_5 === toByte(tmp$ret$3);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      var tmp_6 = _this__u8e3s4.pvq_1.l1(2);
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(92);
      var tmp$ret$4 = Char__toInt_impl_vasixd(this_4);
      tmp_3 = tmp_6 === toByte(tmp$ret$4);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var c = numberToChar(_this__u8e3s4.pvq_1.l1(0));
      if (!(_Char___init__impl__6a9atx(97) <= c ? c <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= c ? c <= _Char___init__impl__6a9atx(90) : false))
        return -1;
      return 3;
    }
    return -1;
  }
  function get_indexOfLastSlash(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    var lastSlash = _this__u8e3s4.pvq_1.wvq(get_SLASH());
    if (!(lastSlash === -1))
      return lastSlash;
    return _this__u8e3s4.pvq_1.wvq(get_BACKSLASH());
  }
  function lastSegmentIsDotDot(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    if (_this__u8e3s4.pvq_1.yvq(get_DOT_DOT())) {
      if (_this__u8e3s4.pvq_1.n1() === 2)
        return true;
      if (_this__u8e3s4.pvq_1.xvq(_this__u8e3s4.pvq_1.n1() - 3 | 0, get_SLASH(), 0, 1))
        return true;
      if (_this__u8e3s4.pvq_1.xvq(_this__u8e3s4.pvq_1.n1() - 3 | 0, get_BACKSLASH(), 0, 1))
        return true;
    }
    return false;
  }
  function get_slash(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    return !(_this__u8e3s4.pvq_1.zvq(get_SLASH()) === -1) ? get_SLASH() : !(_this__u8e3s4.pvq_1.zvq(get_BACKSLASH()) === -1) ? get_BACKSLASH() : null;
  }
  function toSlash(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    var tmp;
    switch (_this__u8e3s4) {
      case '/':
        tmp = get_SLASH();
        break;
      case '\\':
        tmp = get_BACKSLASH();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('not a directory separator: ' + _this__u8e3s4);
    }
    return tmp;
  }
  function toPath(_this__u8e3s4, normalize) {
    _init_properties_Path_kt__cy3pvf();
    var slash = null;
    var result = new Buffer();
    var leadingSlashCount = 0;
    while (_this__u8e3s4.avr(new Long(0, 0), get_SLASH()) || _this__u8e3s4.avr(new Long(0, 0), get_BACKSLASH())) {
      var byte = _this__u8e3s4.ps7();
      var tmp0_elvis_lhs = slash;
      slash = tmp0_elvis_lhs == null ? toSlash_0(byte) : tmp0_elvis_lhs;
      leadingSlashCount = leadingSlashCount + 1 | 0;
    }
    var windowsUncPath = leadingSlashCount >= 2 && equals(slash, get_BACKSLASH());
    if (windowsUncPath) {
      result.tvq(ensureNotNull(slash));
      result.tvq(slash);
    } else if (leadingSlashCount > 0) {
      result.tvq(ensureNotNull(slash));
    } else {
      var limit = _this__u8e3s4.bvr(get_ANY_SLASH());
      var tmp1_elvis_lhs = slash;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        tmp = equalsLong(limit, new Long(-1, -1)) ? toSlash(Companion_getInstance_3().svq_1) : toSlash_0(_this__u8e3s4.lx(limit));
      } else {
        tmp = tmp1_elvis_lhs;
      }
      slash = tmp;
      if (startsWithVolumeLetterAndColon(_this__u8e3s4, slash)) {
        if (equalsLong(limit, new Long(2, 0))) {
          result.qvp(_this__u8e3s4, new Long(3, 0));
        } else {
          result.qvp(_this__u8e3s4, new Long(2, 0));
        }
      }
    }
    var absolute = compare(result.svp_1, new Long(0, 0)) > 0;
    // Inline function 'kotlin.collections.mutableListOf' call
    var canonicalParts = ArrayList_init_$Create$();
    while (!_this__u8e3s4.ms7()) {
      var limit_0 = _this__u8e3s4.bvr(get_ANY_SLASH());
      var part;
      if (equalsLong(limit_0, new Long(-1, -1))) {
        part = _this__u8e3s4.dvr();
      } else {
        part = _this__u8e3s4.cvr(limit_0);
        _this__u8e3s4.ps7();
      }
      if (part.equals(get_DOT_DOT())) {
        if (!absolute || !canonicalParts.r())
          if (!normalize || (!absolute && (canonicalParts.r() || last(canonicalParts).equals(get_DOT_DOT())))) {
            canonicalParts.j1(part);
          } else if (!windowsUncPath || canonicalParts.n1() !== 1) {
            removeLastOrNull(canonicalParts);
          }
      } else if (!part.equals(get_DOT()) && !part.equals(Companion_getInstance_2().evr_1)) {
        canonicalParts.j1(part);
      }
    }
    var inductionVariable = 0;
    var last_0 = canonicalParts.n1();
    if (inductionVariable < last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (i > 0) {
          result.tvq(slash);
        }
        result.tvq(canonicalParts.l1(i));
      }
       while (inductionVariable < last_0);
    if (equalsLong(result.svp_1, new Long(0, 0))) {
      result.tvq(get_DOT());
    }
    return new Path(result.dvr());
  }
  function toSlash_0(_this__u8e3s4) {
    _init_properties_Path_kt__cy3pvf();
    var tmp;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(47);
    if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_0)) {
      tmp = get_SLASH();
    } else {
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(92);
      if (_this__u8e3s4 === Char__toInt_impl_vasixd(this_1)) {
        tmp = get_BACKSLASH();
      } else {
        throw IllegalArgumentException_init_$Create$('not a directory separator: ' + _this__u8e3s4);
      }
    }
    return tmp;
  }
  function startsWithVolumeLetterAndColon(_this__u8e3s4, slash) {
    _init_properties_Path_kt__cy3pvf();
    if (!slash.equals(get_BACKSLASH()))
      return false;
    if (compare(_this__u8e3s4.svp_1, new Long(2, 0)) < 0)
      return false;
    var tmp = _this__u8e3s4.lx(new Long(1, 0));
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(58);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    if (!(tmp === toByte(tmp$ret$0)))
      return false;
    var b = numberToChar(_this__u8e3s4.lx(new Long(0, 0)));
    return (_Char___init__impl__6a9atx(97) <= b ? b <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= b ? b <= _Char___init__impl__6a9atx(90) : false);
  }
  function access$_get_SLASH_$tPathKt_oiy1wy() {
    return get_SLASH();
  }
  function access$_get_BACKSLASH_$tPathKt_hofl47() {
    return get_BACKSLASH();
  }
  function access$_get_DOT_$tPathKt_c0s3mi() {
    return get_DOT();
  }
  function access$rootLength$tPathKt($receiver) {
    return rootLength($receiver);
  }
  function access$_get_indexOfLastSlash_$tPathKt_czkh05($receiver) {
    return get_indexOfLastSlash($receiver);
  }
  function access$lastSegmentIsDotDot$tPathKt($receiver) {
    return lastSegmentIsDotDot($receiver);
  }
  var properties_initialized_Path_kt_a3g6iv;
  function _init_properties_Path_kt__cy3pvf() {
    if (!properties_initialized_Path_kt_a3g6iv) {
      properties_initialized_Path_kt_a3g6iv = true;
      SLASH = Companion_getInstance_2().fvr('/');
      BACKSLASH = Companion_getInstance_2().fvr('\\');
      ANY_SLASH = Companion_getInstance_2().fvr('/\\');
      DOT = Companion_getInstance_2().fvr('.');
      DOT_DOT = Companion_getInstance_2().fvr('..');
    }
  }
  function commonIndexOf_0(_this__u8e3s4, bytes, bytesOffset, byteCount, fromIndex, toIndex) {
    bytesOffset = bytesOffset === VOID ? 0 : bytesOffset;
    byteCount = byteCount === VOID ? bytes.n1() : byteCount;
    toIndex = toIndex === VOID ? new Long(-1, 2147483647) : toIndex;
    checkOffsetAndCount(fromInt(bytes.n1()), fromInt(bytesOffset), fromInt(byteCount));
    var fromIndex_0 = fromIndex;
    // Inline function 'kotlin.check' call
    if (!!_this__u8e3s4.hvr_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    while (true) {
      var result = commonIndexOf(_this__u8e3s4.ivr_1, bytes, fromIndex_0, toIndex, bytesOffset, byteCount);
      if (!equalsLong(result, new Long(-1, -1)))
        return result;
      var lastBufferSize = _this__u8e3s4.ivr_1.svp_1;
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.plus' call
      var this_0 = subtract(lastBufferSize, fromInt(byteCount));
      var nextFromIndex = add(this_0, fromInt(1));
      if (compare(nextFromIndex, toIndex) >= 0)
        return new Long(-1, -1);
      if (!isMatchPossibleByExpandingBuffer(_this__u8e3s4.ivr_1, bytes, bytesOffset, byteCount, fromIndex_0, toIndex)) {
        return new Long(-1, -1);
      }
      if (equalsLong(_this__u8e3s4.gvr_1.jvr(_this__u8e3s4.ivr_1, new Long(8192, 0)), new Long(-1, -1)))
        return new Long(-1, -1);
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = fromIndex_0;
      fromIndex_0 = compare(a, nextFromIndex) >= 0 ? a : nextFromIndex;
    }
  }
  function isMatchPossibleByExpandingBuffer(_this__u8e3s4, bytes, bytesOffset, byteCount, fromIndex, toIndex) {
    if (compare(_this__u8e3s4.svp_1, toIndex) < 0)
      return true;
    var tmp0 = new Long(1, 0);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(_this__u8e3s4.svp_1, toIndex);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = add(this_0, fromInt(1));
    var tmp$ret$1 = compare(tmp0, b) >= 0 ? tmp0 : b;
    var begin = convertToInt(tmp$ret$1);
    // Inline function 'kotlin.Long.plus' call
    var this_1 = subtract(_this__u8e3s4.svp_1, fromIndex);
    // Inline function 'okio.minOf' call
    var b_0 = add(this_1, fromInt(1));
    // Inline function 'kotlin.comparisons.minOf' call
    var a = fromInt(byteCount);
    var tmp$ret$3 = compare(a, b_0) <= 0 ? a : b_0;
    var limit = convertToInt(tmp$ret$3);
    var inductionVariable = limit - 1 | 0;
    if (begin <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0_0 = _this__u8e3s4.svp_1;
        // Inline function 'kotlin.Long.minus' call
        var other = i;
        var tmp$ret$5 = subtract(tmp0_0, fromInt(other));
        if (_this__u8e3s4.kvr(tmp$ret$5, bytes, bytesOffset, i)) {
          return true;
        }
      }
       while (!(i === begin));
    return false;
  }
  function segment(_this__u8e3s4, pos) {
    var i = binarySearch(_this__u8e3s4.pvr_1, pos + 1 | 0, 0, _this__u8e3s4.ovr_1.length);
    return i >= 0 ? i : ~i;
  }
  function binarySearch(_this__u8e3s4, value, fromIndex, toIndex) {
    var left = fromIndex;
    var right = toIndex - 1 | 0;
    while (left <= right) {
      var mid = (left + right | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4[mid];
      if (midVal < value)
        left = mid + 1 | 0;
      else if (midVal > value)
        right = mid - 1 | 0;
      else
        return mid;
    }
    return (-left | 0) - 1 | 0;
  }
  function processChunk($this, input, pos) {
    var words = $this.tvr_1;
    var pos_0 = pos;
    var inductionVariable = 0;
    if (inductionVariable < 16)
      do {
        var w = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = pos_0;
        pos_0 = _unary__edvuaz + 1 | 0;
        // Inline function 'okio.and' call
        var tmp = (input[_unary__edvuaz] & 255) << 24;
        var _unary__edvuaz_0 = pos_0;
        pos_0 = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'okio.and' call
        var tmp_0 = tmp | (input[_unary__edvuaz_0] & 255) << 16;
        var _unary__edvuaz_1 = pos_0;
        pos_0 = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'okio.and' call
        var tmp_1 = tmp_0 | (input[_unary__edvuaz_1] & 255) << 8;
        var _unary__edvuaz_2 = pos_0;
        pos_0 = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'okio.and' call
        words[w] = tmp_1 | input[_unary__edvuaz_2] & 255;
      }
       while (inductionVariable < 16);
    var inductionVariable_0 = 16;
    if (inductionVariable_0 < 64)
      do {
        var w_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var w15 = words[w_0 - 15 | 0];
        var s0 = (w15 >>> 7 | 0 | w15 << 25) ^ (w15 >>> 18 | 0 | w15 << 14) ^ (w15 >>> 3 | 0);
        var w2 = words[w_0 - 2 | 0];
        var s1 = (w2 >>> 17 | 0 | w2 << 15) ^ (w2 >>> 19 | 0 | w2 << 13) ^ (w2 >>> 10 | 0);
        var w16 = words[w_0 - 16 | 0];
        var w7 = words[w_0 - 7 | 0];
        words[w_0] = ((w16 + s0 | 0) + w7 | 0) + s1 | 0;
      }
       while (inductionVariable_0 < 64);
    hash($this, words);
  }
  function hash($this, words) {
    var localK = Companion_getInstance_0().cvs_1;
    var a = $this.uvr_1;
    var b = $this.vvr_1;
    var c = $this.wvr_1;
    var d = $this.xvr_1;
    var e = $this.yvr_1;
    var f = $this.zvr_1;
    var g = $this.avs_1;
    var h = $this.bvs_1;
    var inductionVariable = 0;
    if (inductionVariable < 64)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s0 = (a >>> 2 | 0 | a << 30) ^ (a >>> 13 | 0 | a << 19) ^ (a >>> 22 | 0 | a << 10);
        var s1 = (e >>> 6 | 0 | e << 26) ^ (e >>> 11 | 0 | e << 21) ^ (e >>> 25 | 0 | e << 7);
        var ch = e & f ^ ~e & g;
        var maj = a & b ^ a & c ^ b & c;
        var t1 = (((h + s1 | 0) + ch | 0) + localK[i] | 0) + words[i] | 0;
        var t2 = s0 + maj | 0;
        h = g;
        g = f;
        f = e;
        e = d + t1 | 0;
        d = c;
        c = b;
        b = a;
        a = t1 + t2 | 0;
      }
       while (inductionVariable < 64);
    $this.uvr_1 = $this.uvr_1 + a | 0;
    $this.vvr_1 = $this.vvr_1 + b | 0;
    $this.wvr_1 = $this.wvr_1 + c | 0;
    $this.xvr_1 = $this.xvr_1 + d | 0;
    $this.yvr_1 = $this.yvr_1 + e | 0;
    $this.zvr_1 = $this.zvr_1 + f | 0;
    $this.avs_1 = $this.avs_1 + g | 0;
    $this.bvs_1 = $this.bvs_1 + h | 0;
  }
  function reset($this) {
    $this.qvr_1 = new Long(0, 0);
    fill($this.rvr_1, 0);
    $this.svr_1 = 0;
    fill_0($this.tvr_1, 0);
    $this.uvr_1 = 1779033703;
    $this.vvr_1 = -1150833019;
    $this.wvr_1 = 1013904242;
    $this.xvr_1 = -1521486534;
    $this.yvr_1 = 1359893119;
    $this.zvr_1 = -1694144372;
    $this.avs_1 = 528734635;
    $this.bvs_1 = 1541459225;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.cvs_1 = new Int32Array([1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998]);
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function Sha256() {
    Companion_getInstance_0();
    this.qvr_1 = new Long(0, 0);
    this.rvr_1 = new Int8Array(64);
    this.svr_1 = 0;
    this.tvr_1 = new Int32Array(64);
    this.uvr_1 = 1779033703;
    this.vvr_1 = -1150833019;
    this.wvr_1 = 1013904242;
    this.xvr_1 = -1521486534;
    this.yvr_1 = 1359893119;
    this.zvr_1 = -1694144372;
    this.avs_1 = 528734635;
    this.bvs_1 = 1541459225;
  }
  protoOf(Sha256).dvs = function (input, offset, byteCount) {
    var tmp = this;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.qvr_1;
    tmp.qvr_1 = add(this_0, fromInt(byteCount));
    var pos = offset;
    var limit = pos + byteCount | 0;
    var unprocessed = this.rvr_1;
    var unprocessedLimit = this.svr_1;
    if (unprocessedLimit > 0) {
      if ((unprocessedLimit + byteCount | 0) < 64) {
        // Inline function 'kotlin.collections.copyInto' call
        var startIndex = pos;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = input;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, unprocessed, unprocessedLimit, startIndex, limit);
        this.svr_1 = unprocessedLimit + byteCount | 0;
        return Unit_instance;
      }
      var consumeByteCount = 64 - unprocessedLimit | 0;
      var tmp6 = pos;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = pos + consumeByteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_1 = input;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_1, unprocessed, unprocessedLimit, tmp6, endIndex);
      processChunk(this, unprocessed, 0);
      this.svr_1 = 0;
      pos = pos + consumeByteCount | 0;
    }
    while (pos < limit) {
      var nextPos = pos + 64 | 0;
      if (nextPos > limit) {
        // Inline function 'kotlin.collections.copyInto' call
        var startIndex_0 = pos;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = input;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_2, unprocessed, 0, startIndex_0, limit);
        this.svr_1 = limit - pos | 0;
        return Unit_instance;
      }
      processChunk(this, input, pos);
      pos = nextPos;
    }
  };
  protoOf(Sha256).evs = function () {
    var unprocessed = this.rvr_1;
    var unprocessedLimit = this.svr_1;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.qvr_1;
    var messageLengthBits = multiply(this_0, fromInt(8));
    var _unary__edvuaz = unprocessedLimit;
    unprocessedLimit = _unary__edvuaz + 1 | 0;
    unprocessed[_unary__edvuaz] = -128;
    if (unprocessedLimit > 56) {
      fill(unprocessed, 0, unprocessedLimit, 64);
      processChunk(this, unprocessed, 0);
      fill(unprocessed, 0, 0, unprocessedLimit);
    } else {
      fill(unprocessed, 0, unprocessedLimit, 56);
    }
    unprocessed[56] = convertToByte(shiftRightUnsigned(messageLengthBits, 56));
    unprocessed[57] = convertToByte(shiftRightUnsigned(messageLengthBits, 48));
    unprocessed[58] = convertToByte(shiftRightUnsigned(messageLengthBits, 40));
    unprocessed[59] = convertToByte(shiftRightUnsigned(messageLengthBits, 32));
    unprocessed[60] = convertToByte(shiftRightUnsigned(messageLengthBits, 24));
    unprocessed[61] = convertToByte(shiftRightUnsigned(messageLengthBits, 16));
    unprocessed[62] = convertToByte(shiftRightUnsigned(messageLengthBits, 8));
    unprocessed[63] = convertToByte(messageLengthBits);
    processChunk(this, unprocessed, 0);
    var a = this.uvr_1;
    var b = this.vvr_1;
    var c = this.wvr_1;
    var d = this.xvr_1;
    var e = this.yvr_1;
    var f = this.zvr_1;
    var g = this.avs_1;
    var h = this.bvs_1;
    reset(this);
    // Inline function 'kotlin.byteArrayOf' call
    return new Int8Array([toByte(a >> 24), toByte(a >> 16), toByte(a >> 8), toByte(a), toByte(b >> 24), toByte(b >> 16), toByte(b >> 8), toByte(b), toByte(c >> 24), toByte(c >> 16), toByte(c >> 8), toByte(c), toByte(d >> 24), toByte(d >> 16), toByte(d >> 8), toByte(d), toByte(e >> 24), toByte(e >> 16), toByte(e >> 8), toByte(e), toByte(f >> 24), toByte(f >> 16), toByte(f >> 8), toByte(f), toByte(g >> 24), toByte(g >> 16), toByte(g >> 8), toByte(g), toByte(h >> 24), toByte(h >> 16), toByte(h >> 8), toByte(h)]);
  };
  function Companion_1() {
    Companion_instance_1 = this;
    this.fvs_1 = Companion_getInstance_3().gvs(get_tmpdir());
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function FileSystem() {
    Companion_getInstance_1();
  }
  protoOf(FileSystem).nvp = function (path) {
    return commonExists(this, path);
  };
  protoOf(FileSystem).hvp = function (file, mustExist, $super) {
    mustExist = mustExist === VOID ? false : mustExist;
    return $super === VOID ? this.gvp(file, mustExist) : $super.gvp.call(this, file, mustExist);
  };
  protoOf(FileSystem).jvp = function (dir, mustCreate, $super) {
    mustCreate = mustCreate === VOID ? false : mustCreate;
    var tmp;
    if ($super === VOID) {
      this.ivp(dir, mustCreate);
      tmp = Unit_instance;
    } else {
      tmp = $super.ivp.call(this, dir, mustCreate);
    }
    return tmp;
  };
  protoOf(FileSystem).ovp = function (dir, mustCreate) {
    return commonCreateDirectories(this, dir, mustCreate);
  };
  protoOf(FileSystem).pvp = function (dir, mustCreate, $super) {
    mustCreate = mustCreate === VOID ? false : mustCreate;
    var tmp;
    if ($super === VOID) {
      this.ovp(dir, mustCreate);
      tmp = Unit_instance;
    } else {
      tmp = $super.ovp.call(this, dir, mustCreate);
    }
    return tmp;
  };
  protoOf(FileSystem).mvp = function (path, mustExist, $super) {
    mustExist = mustExist === VOID ? false : mustExist;
    var tmp;
    if ($super === VOID) {
      this.lvp(path, mustExist);
      tmp = Unit_instance;
    } else {
      tmp = $super.lvp.call(this, path, mustExist);
    }
    return tmp;
  };
  protoOf(FileSystem).j4 = function () {
  };
  function get_tmpdir() {
    var tmp0_safe_receiver = get_os();
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tmpdir();
    var tmp1_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp1_elvis_lhs == null ? '/tmp' : tmp1_elvis_lhs;
  }
  function get_os() {
    var tmp;
    try {
      tmp = require('os');
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function get_PLATFORM_DIRECTORY_SEPARATOR() {
    var tmp0_safe_receiver = get_path();
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sep;
    var tmp1_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp1_elvis_lhs == null ? '/' : tmp1_elvis_lhs;
  }
  function get_path() {
    var tmp;
    try {
      tmp = require('path');
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$0 = new Int8Array([]);
    tmp.evr_1 = new ByteString(tmp$ret$0);
  }
  protoOf(Companion_2).hvs = function (_this__u8e3s4, offset, byteCount) {
    // Inline function 'okio.internal.commonToByteString' call
    checkOffsetAndCount(fromInt(_this__u8e3s4.length), fromInt(offset), fromInt(byteCount));
    return new ByteString(copyOfRange(_this__u8e3s4, offset, offset + byteCount | 0));
  };
  protoOf(Companion_2).ivs = function (_this__u8e3s4, offset, byteCount, $super) {
    offset = offset === VOID ? 0 : offset;
    byteCount = byteCount === VOID ? _this__u8e3s4.length : byteCount;
    return $super === VOID ? this.hvs(_this__u8e3s4, offset, byteCount) : $super.hvs.call(this, _this__u8e3s4, offset, byteCount);
  };
  protoOf(Companion_2).fvr = function (_this__u8e3s4) {
    // Inline function 'okio.internal.commonEncodeUtf8' call
    var byteString = new ByteString(asUtf8ToByteArray(_this__u8e3s4));
    byteString.jvs(_this__u8e3s4);
    return byteString;
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function ByteString(data) {
    Companion_getInstance_2();
    this.kvq_1 = data;
    this.lvq_1 = 0;
    this.mvq_1 = null;
  }
  protoOf(ByteString).kvs = function (value) {
  };
  protoOf(ByteString).jvs = function (value) {
  };
  protoOf(ByteString).lvs = function () {
    // Inline function 'okio.internal.commonUtf8' call
    var result = this.mvq_1;
    if (result == null) {
      result = toUtf8String(this.nvq());
      this.jvs(result);
    }
    return result;
  };
  protoOf(ByteString).mvs = function () {
    // Inline function 'okio.internal.commonHex' call
    var result = charArray(imul(this.kvq_1.length, 2));
    var c = 0;
    var indexedObject = this.kvq_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var b = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = c;
      c = _unary__edvuaz + 1 | 0;
      var tmp = get_HEX_DIGIT_CHARS();
      // Inline function 'okio.shr' call
      result[_unary__edvuaz] = tmp[b >> 4 & 15];
      var _unary__edvuaz_0 = c;
      c = _unary__edvuaz_0 + 1 | 0;
      var tmp_0 = get_HEX_DIGIT_CHARS();
      // Inline function 'okio.and' call
      result[_unary__edvuaz_0] = tmp_0[b & 15];
    }
    return concatToString_0(result);
  };
  protoOf(ByteString).nvs = function () {
    return this.ovs(new Sha256());
  };
  protoOf(ByteString).ovs = function (hashFunction) {
    hashFunction.dvs(this.kvq_1, 0, this.n1());
    var digestBytes = hashFunction.evs();
    return new ByteString(digestBytes);
  };
  protoOf(ByteString).dmu = function (beginIndex, endIndex) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonSubstring' call
      // Inline function 'kotlin.require' call
      if (!(beginIndex >= 0)) {
        var message = 'beginIndex < 0';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!(endIndex <= this.kvq_1.length)) {
        var message_0 = 'endIndex > length(' + this.kvq_1.length + ')';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var subLen = endIndex - beginIndex | 0;
      // Inline function 'kotlin.require' call
      if (!(subLen >= 0)) {
        var message_1 = 'endIndex < beginIndex';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
      if (beginIndex === 0 && endIndex === this.kvq_1.length) {
        tmp$ret$0 = this;
        break $l$block;
      }
      tmp$ret$0 = new ByteString(copyOfRange(this.kvq_1, beginIndex, endIndex));
    }
    return tmp$ret$0;
  };
  protoOf(ByteString).pvs = function (beginIndex, endIndex, $super) {
    beginIndex = beginIndex === VOID ? 0 : beginIndex;
    endIndex = endIndex === VOID ? this.n1() : endIndex;
    return $super === VOID ? this.dmu(beginIndex, endIndex) : $super.dmu.call(this, beginIndex, endIndex);
  };
  protoOf(ByteString).qvs = function (pos) {
    if (pos >= this.n1() || pos < 0)
      throw new ArrayIndexOutOfBoundsException('size=' + this.n1() + ' pos=' + pos);
    // Inline function 'okio.internal.commonGetByte' call
    return this.kvq_1[pos];
  };
  protoOf(ByteString).l1 = function (index) {
    return this.qvs(index);
  };
  protoOf(ByteString).n1 = function () {
    return this.rvs();
  };
  protoOf(ByteString).rvs = function () {
    // Inline function 'okio.internal.commonGetSize' call
    return this.kvq_1.length;
  };
  protoOf(ByteString).svs = function () {
    // Inline function 'okio.internal.commonToByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.kvq_1.slice();
  };
  protoOf(ByteString).nvq = function () {
    // Inline function 'okio.internal.commonInternalArray' call
    return this.kvq_1;
  };
  protoOf(ByteString).tvs = function (buffer, offset, byteCount) {
    return commonWrite(this, buffer, offset, byteCount);
  };
  protoOf(ByteString).xvq = function (offset, other, otherOffset, byteCount) {
    // Inline function 'okio.internal.commonRangeEquals' call
    return other.uvs(otherOffset, this.kvq_1, offset, byteCount);
  };
  protoOf(ByteString).uvs = function (offset, other, otherOffset, byteCount) {
    // Inline function 'okio.internal.commonRangeEquals' call
    return offset >= 0 && offset <= (this.kvq_1.length - byteCount | 0) && otherOffset >= 0 && otherOffset <= (other.length - byteCount | 0) && arrayRangeEquals(this.kvq_1, offset, other, otherOffset, byteCount);
  };
  protoOf(ByteString).vvs = function (prefix) {
    // Inline function 'okio.internal.commonStartsWith' call
    return this.xvq(0, prefix, 0, prefix.n1());
  };
  protoOf(ByteString).yvq = function (suffix) {
    // Inline function 'okio.internal.commonEndsWith' call
    return this.xvq(this.n1() - suffix.n1() | 0, suffix, 0, suffix.n1());
  };
  protoOf(ByteString).vvq = function (other, fromIndex) {
    return this.wvs(other.nvq(), fromIndex);
  };
  protoOf(ByteString).zvq = function (other, fromIndex, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    return $super === VOID ? this.vvq(other, fromIndex) : $super.vvq.call(this, other, fromIndex);
  };
  protoOf(ByteString).wvs = function (other, fromIndex) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonIndexOf' call
      var limit = this.kvq_1.length - other.length | 0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var inductionVariable = Math.max(fromIndex, 0);
      if (inductionVariable <= limit)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (arrayRangeEquals(this.kvq_1, i, other, 0, other.length)) {
            tmp$ret$0 = i;
            break $l$block;
          }
        }
         while (!(i === limit));
      tmp$ret$0 = -1;
    }
    return tmp$ret$0;
  };
  protoOf(ByteString).xvs = function (other, fromIndex) {
    // Inline function 'okio.internal.commonLastIndexOf' call
    return this.yvs(other.nvq(), fromIndex);
  };
  protoOf(ByteString).wvq = function (other, fromIndex, $super) {
    fromIndex = fromIndex === VOID ? this.n1() : fromIndex;
    return $super === VOID ? this.xvs(other, fromIndex) : $super.xvs.call(this, other, fromIndex);
  };
  protoOf(ByteString).yvs = function (other, fromIndex) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonLastIndexOf' call
      var limit = this.kvq_1.length - other.length | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var inductionVariable = Math.min(fromIndex, limit);
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (arrayRangeEquals(this.kvq_1, i, other, 0, other.length)) {
            tmp$ret$0 = i;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$0 = -1;
    }
    return tmp$ret$0;
  };
  protoOf(ByteString).equals = function (other) {
    // Inline function 'okio.internal.commonEquals' call
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      if (other instanceof ByteString) {
        tmp = (other.n1() === this.kvq_1.length && other.uvs(0, this.kvq_1, 0, this.kvq_1.length));
      } else {
        tmp = false;
      }
    }
    return tmp;
  };
  protoOf(ByteString).hashCode = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var result = this.lvq_1;
      if (!(result === 0)) {
        tmp$ret$0 = result;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = contentHashCode(this.kvq_1);
      this.kvs(this_0);
      tmp$ret$0 = this_0;
    }
    return tmp$ret$0;
  };
  protoOf(ByteString).zvs = function (other) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonCompareTo' call
      var sizeA = this.n1();
      var sizeB = other.n1();
      var i = 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var size = Math.min(sizeA, sizeB);
      $l$loop: while (i < size) {
        // Inline function 'okio.and' call
        var byteA = this.l1(i) & 255;
        // Inline function 'okio.and' call
        var byteB = other.l1(i) & 255;
        if (byteA === byteB) {
          i = i + 1 | 0;
          continue $l$loop;
        }
        tmp$ret$0 = byteA < byteB ? -1 : 1;
        break $l$block_0;
      }
      if (sizeA === sizeB) {
        tmp$ret$0 = 0;
        break $l$block_0;
      }
      tmp$ret$0 = sizeA < sizeB ? -1 : 1;
    }
    return tmp$ret$0;
  };
  protoOf(ByteString).d = function (other) {
    return this.zvs(other instanceof ByteString ? other : THROW_CCE());
  };
  protoOf(ByteString).toString = function () {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'okio.internal.commonToString' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (this.kvq_1.length === 0) {
        tmp$ret$0 = '[size=0]';
        break $l$block_1;
      }
      var i = access$codePointIndexToCharIndex$tByteStringKt(this.kvq_1, 64);
      if (i === -1) {
        var tmp;
        if (this.kvq_1.length <= 64) {
          tmp = '[hex=' + this.mvs() + ']';
        } else {
          var tmp_0 = this.kvq_1.length;
          var tmp$ret$2;
          $l$block_0: {
            // Inline function 'okio.internal.commonSubstring' call
            // Inline function 'kotlin.require' call
            if (!(0 >= 0)) {
              var message = 'beginIndex < 0';
              throw IllegalArgumentException_init_$Create$(toString(message));
            }
            // Inline function 'kotlin.require' call
            if (!(64 <= this.kvq_1.length)) {
              var message_0 = 'endIndex > length(' + this.kvq_1.length + ')';
              throw IllegalArgumentException_init_$Create$(toString(message_0));
            }
            var subLen = 64 - 0 | 0;
            // Inline function 'kotlin.require' call
            if (!(subLen >= 0)) {
              var message_1 = 'endIndex < beginIndex';
              throw IllegalArgumentException_init_$Create$(toString(message_1));
            }
            if (0 === 0 && 64 === this.kvq_1.length) {
              tmp$ret$2 = this;
              break $l$block_0;
            }
            tmp$ret$2 = new ByteString(copyOfRange(this.kvq_1, 0, 64));
          }
          tmp = '[size=' + tmp_0 + ' hex=' + tmp$ret$2.mvs() + '\u2026]';
        }
        tmp$ret$0 = tmp;
        break $l$block_1;
      }
      var text = this.lvs();
      var safeText = replace(replace(replace(substring(text, 0, i), '\\', '\\\\'), '\n', '\\n'), '\r', '\\r');
      var tmp_1;
      if (i < text.length) {
        tmp_1 = '[size=' + this.kvq_1.length + ' text=' + safeText + '\u2026]';
      } else {
        tmp_1 = '[text=' + safeText + ']';
      }
      tmp$ret$0 = tmp_1;
    }
    return tmp$ret$0;
  };
  function toByteString($this) {
    return new ByteString($this.svs());
  }
  function SegmentedByteString(segments, directory) {
    ByteString.call(this, Companion_getInstance_2().evr_1.kvq_1);
    this.ovr_1 = segments;
    this.pvr_1 = directory;
  }
  protoOf(SegmentedByteString).mvs = function () {
    return toByteString(this).mvs();
  };
  protoOf(SegmentedByteString).dmu = function (beginIndex, endIndex) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonSubstring' call
      // Inline function 'kotlin.require' call
      if (!(beginIndex >= 0)) {
        var message = 'beginIndex=' + beginIndex + ' < 0';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!(endIndex <= this.n1())) {
        var message_0 = 'endIndex=' + endIndex + ' > length(' + this.n1() + ')';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var subLen = endIndex - beginIndex | 0;
      // Inline function 'kotlin.require' call
      if (!(subLen >= 0)) {
        var message_1 = 'endIndex=' + endIndex + ' < beginIndex=' + beginIndex;
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
      if (beginIndex === 0 && endIndex === this.n1()) {
        tmp$ret$0 = this;
        break $l$block_0;
      } else if (beginIndex === endIndex) {
        tmp$ret$0 = Companion_getInstance_2().evr_1;
        break $l$block_0;
      }
      var beginSegment = segment(this, beginIndex);
      var endSegment = segment(this, endIndex - 1 | 0);
      var newSegments = copyOfRange_0(this.ovr_1, beginSegment, endSegment + 1 | 0);
      var newDirectory = new Int32Array(imul(newSegments.length, 2));
      var index = 0;
      var inductionVariable = beginSegment;
      if (inductionVariable <= endSegment)
        do {
          var s = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = index;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = this.pvr_1[s] - beginIndex | 0;
          newDirectory[tmp] = Math.min(a, subLen);
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          newDirectory[_unary__edvuaz + newSegments.length | 0] = this.pvr_1[s + this.ovr_1.length | 0];
        }
         while (!(s === endSegment));
      var segmentOffset = beginSegment === 0 ? 0 : this.pvr_1[beginSegment - 1 | 0];
      var _index_0__fvwizt = newSegments.length;
      newDirectory[_index_0__fvwizt] = newDirectory[_index_0__fvwizt] + (beginIndex - segmentOffset | 0) | 0;
      tmp$ret$0 = new SegmentedByteString(newSegments, newDirectory);
    }
    return tmp$ret$0;
  };
  protoOf(SegmentedByteString).qvs = function (pos) {
    // Inline function 'okio.internal.commonInternalGet' call
    checkOffsetAndCount(fromInt(this.pvr_1[this.ovr_1.length - 1 | 0]), fromInt(pos), new Long(1, 0));
    var segment_0 = segment(this, pos);
    var segmentOffset = segment_0 === 0 ? 0 : this.pvr_1[segment_0 - 1 | 0];
    var segmentPos = this.pvr_1[segment_0 + this.ovr_1.length | 0];
    return this.ovr_1[segment_0][(pos - segmentOffset | 0) + segmentPos | 0];
  };
  protoOf(SegmentedByteString).rvs = function () {
    // Inline function 'okio.internal.commonGetSize' call
    return this.pvr_1[this.ovr_1.length - 1 | 0];
  };
  protoOf(SegmentedByteString).svs = function () {
    // Inline function 'okio.internal.commonToByteArray' call
    var result = new Int8Array(this.n1());
    var resultPos = 0;
    // Inline function 'okio.internal.forEachSegment' call
    var segmentCount = this.ovr_1.length;
    var s = 0;
    var pos = 0;
    while (s < segmentCount) {
      var segmentPos = this.pvr_1[segmentCount + s | 0];
      var nextSegmentOffset = this.pvr_1[s];
      var tmp0 = this.ovr_1[s];
      var byteCount = nextSegmentOffset - pos | 0;
      var tmp4 = resultPos;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = segmentPos + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, result, tmp4, segmentPos, endIndex);
      resultPos = resultPos + byteCount | 0;
      pos = nextSegmentOffset;
      s = s + 1 | 0;
    }
    return result;
  };
  protoOf(SegmentedByteString).tvs = function (buffer, offset, byteCount) {
    // Inline function 'okio.internal.commonWrite' call
    var endIndex = offset + byteCount | 0;
    var s = segment(this, offset);
    var pos = offset;
    while (pos < endIndex) {
      var segmentOffset = s === 0 ? 0 : this.pvr_1[s - 1 | 0];
      var segmentSize = this.pvr_1[s] - segmentOffset | 0;
      var segmentPos = this.pvr_1[this.ovr_1.length + s | 0];
      // Inline function 'kotlin.comparisons.minOf' call
      var b = segmentOffset + segmentSize | 0;
      var byteCount_0 = Math.min(endIndex, b) - pos | 0;
      var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
      var data = this.ovr_1[s];
      var segment_0 = Segment_init_$Create$_0(data, offset_0, offset_0 + byteCount_0 | 0, true, false);
      if (buffer.rvp_1 == null) {
        segment_0.zvp_1 = segment_0;
        segment_0.yvp_1 = segment_0.zvp_1;
        buffer.rvp_1 = segment_0.yvp_1;
      } else {
        ensureNotNull(ensureNotNull(buffer.rvp_1).zvp_1).dvq(segment_0);
      }
      pos = pos + byteCount_0 | 0;
      s = s + 1 | 0;
    }
    var tmp = buffer;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = buffer.svp_1;
    tmp.svp_1 = add(this_0, fromInt(byteCount));
    return Unit_instance;
  };
  protoOf(SegmentedByteString).xvq = function (offset, other, otherOffset, byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonRangeEquals' call
      if (offset < 0 || offset > (this.n1() - byteCount | 0)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var otherOffset_0 = otherOffset;
      var endIndex = offset + byteCount | 0;
      var s = segment(this, offset);
      var pos = offset;
      while (pos < endIndex) {
        var segmentOffset = s === 0 ? 0 : this.pvr_1[s - 1 | 0];
        var segmentSize = this.pvr_1[s] - segmentOffset | 0;
        var segmentPos = this.pvr_1[this.ovr_1.length + s | 0];
        // Inline function 'kotlin.comparisons.minOf' call
        var b = segmentOffset + segmentSize | 0;
        var byteCount_0 = Math.min(endIndex, b) - pos | 0;
        var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
        var data = this.ovr_1[s];
        if (!other.uvs(otherOffset_0, data, offset_0, byteCount_0)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
        pos = pos + byteCount_0 | 0;
        s = s + 1 | 0;
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SegmentedByteString).uvs = function (offset, other, otherOffset, byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonRangeEquals' call
      if (offset < 0 || offset > (this.n1() - byteCount | 0) || otherOffset < 0 || otherOffset > (other.length - byteCount | 0)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var otherOffset_0 = otherOffset;
      var endIndex = offset + byteCount | 0;
      var s = segment(this, offset);
      var pos = offset;
      while (pos < endIndex) {
        var segmentOffset = s === 0 ? 0 : this.pvr_1[s - 1 | 0];
        var segmentSize = this.pvr_1[s] - segmentOffset | 0;
        var segmentPos = this.pvr_1[this.ovr_1.length + s | 0];
        // Inline function 'kotlin.comparisons.minOf' call
        var b = segmentOffset + segmentSize | 0;
        var byteCount_0 = Math.min(endIndex, b) - pos | 0;
        var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
        var data = this.ovr_1[s];
        if (!arrayRangeEquals(data, offset_0, other, otherOffset_0, byteCount_0)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
        pos = pos + byteCount_0 | 0;
        s = s + 1 | 0;
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SegmentedByteString).wvs = function (other, fromIndex) {
    return toByteString(this).wvs(other, fromIndex);
  };
  protoOf(SegmentedByteString).yvs = function (other, fromIndex) {
    return toByteString(this).yvs(other, fromIndex);
  };
  protoOf(SegmentedByteString).ovs = function (hashFunction) {
    // Inline function 'okio.internal.forEachSegment' call
    var segmentCount = this.ovr_1.length;
    var s = 0;
    var pos = 0;
    while (s < segmentCount) {
      var segmentPos = this.pvr_1[segmentCount + s | 0];
      var nextSegmentOffset = this.pvr_1[s];
      var tmp0 = this.ovr_1[s];
      var byteCount = nextSegmentOffset - pos | 0;
      hashFunction.dvs(tmp0, segmentPos, byteCount);
      pos = nextSegmentOffset;
      s = s + 1 | 0;
    }
    var digestBytes = hashFunction.evs();
    return new ByteString(digestBytes);
  };
  protoOf(SegmentedByteString).nvq = function () {
    return this.svs();
  };
  protoOf(SegmentedByteString).equals = function (other) {
    // Inline function 'okio.internal.commonEquals' call
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      if (other instanceof ByteString) {
        tmp = (other.n1() === this.n1() && this.xvq(0, other, 0, this.n1()));
      } else {
        tmp = false;
      }
    }
    return tmp;
  };
  protoOf(SegmentedByteString).hashCode = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var result = this.lvq_1;
      if (!(result === 0)) {
        tmp$ret$0 = result;
        break $l$block;
      }
      result = 1;
      // Inline function 'okio.internal.forEachSegment' call
      var segmentCount = this.ovr_1.length;
      var s = 0;
      var pos = 0;
      while (s < segmentCount) {
        var segmentPos = this.pvr_1[segmentCount + s | 0];
        var nextSegmentOffset = this.pvr_1[s];
        var tmp0 = this.ovr_1[s];
        var i = segmentPos;
        var limit = segmentPos + (nextSegmentOffset - pos | 0) | 0;
        while (i < limit) {
          result = imul(31, result) + tmp0[i] | 0;
          i = i + 1 | 0;
        }
        pos = nextSegmentOffset;
        s = s + 1 | 0;
      }
      this.kvs(result);
      tmp$ret$0 = result;
    }
    return tmp$ret$0;
  };
  protoOf(SegmentedByteString).toString = function () {
    return toByteString(this).toString();
  };
  function Buffer() {
    this.rvp_1 = null;
    this.svp_1 = new Long(0, 0);
  }
  protoOf(Buffer).ms7 = function () {
    return equalsLong(this.svp_1, new Long(0, 0));
  };
  protoOf(Buffer).lx = function (pos) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'okio.internal.commonGet' call
      checkOffsetAndCount(this.svp_1, pos, new Long(1, 0));
      $l$block_4: {
        // Inline function 'okio.internal.seek' call
        var tmp0_elvis_lhs = this.rvp_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var offset = new Long(-1, -1);
          tmp$ret$0 = ensureNotNull(null).tvp_1[convertToInt(subtract(add(numberToLong(null.uvp_1), pos), offset))];
          break $l$block_3;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        if (compare(subtract(this.svp_1, pos), pos) < 0) {
          var offset_0 = this.svp_1;
          while (compare(offset_0, pos) > 0) {
            s = ensureNotNull(s.zvp_1);
            offset_0 = subtract(offset_0, fromInt(s.vvp_1 - s.uvp_1 | 0));
          }
          var tmp0 = s;
          var offset_1 = offset_0;
          tmp$ret$0 = ensureNotNull(tmp0).tvp_1[convertToInt(subtract(add(numberToLong(tmp0.uvp_1), pos), offset_1))];
          break $l$block_3;
        } else {
          var offset_2 = new Long(0, 0);
          $l$loop: while (true) {
            var tmp0_0 = offset_2;
            // Inline function 'kotlin.Long.plus' call
            var other = s.vvp_1 - s.uvp_1 | 0;
            var nextOffset = add(tmp0_0, fromInt(other));
            if (compare(nextOffset, pos) > 0)
              break $l$loop;
            s = ensureNotNull(s.yvp_1);
            offset_2 = nextOffset;
          }
          var tmp0_1 = s;
          var offset_3 = offset_2;
          tmp$ret$0 = ensureNotNull(tmp0_1).tvp_1[convertToInt(subtract(add(numberToLong(tmp0_1.uvp_1), pos), offset_3))];
          break $l$block_3;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).avt = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonCompleteSegmentByteCount' call
      var result = this.svp_1;
      if (equalsLong(result, new Long(0, 0))) {
        tmp$ret$0 = new Long(0, 0);
        break $l$block;
      }
      var tail = ensureNotNull(ensureNotNull(this.rvp_1).zvp_1);
      if (tail.vvp_1 < 8192 && tail.xvp_1) {
        result = subtract(result, fromInt(tail.vvp_1 - tail.uvp_1 | 0));
      }
      tmp$ret$0 = result;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).ps7 = function () {
    // Inline function 'okio.internal.commonReadByte' call
    if (equalsLong(this.svp_1, new Long(0, 0)))
      throw EOFException_init_$Create$();
    var segment = ensureNotNull(this.rvp_1);
    var pos = segment.uvp_1;
    var limit = segment.vvp_1;
    var data = segment.tvp_1;
    var _unary__edvuaz = pos;
    pos = _unary__edvuaz + 1 | 0;
    var b = data[_unary__edvuaz];
    this.svp_1 = subtract(this.svp_1, new Long(1, 0));
    if (pos === limit) {
      this.rvp_1 = segment.k3j();
      SegmentPool_instance.jvq(segment);
    } else {
      segment.uvp_1 = pos;
    }
    return b;
  };
  protoOf(Buffer).dvr = function () {
    // Inline function 'okio.internal.commonReadByteString' call
    return this.cvr(this.svp_1);
  };
  protoOf(Buffer).cvr = function (byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonReadByteString' call
      // Inline function 'kotlin.require' call
      if (!(compare(byteCount, new Long(0, 0)) >= 0 && compare(byteCount, new Long(2147483647, 0)) <= 0)) {
        var message = 'byteCount: ' + byteCount.toString();
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      if (compare(this.svp_1, byteCount) < 0)
        throw EOFException_init_$Create$();
      if (compare(byteCount, new Long(4096, 0)) >= 0) {
        // Inline function 'kotlin.also' call
        var this_0 = this.cvt(convertToInt(byteCount));
        this.is8(byteCount);
        tmp$ret$0 = this_0;
        break $l$block_0;
      } else {
        tmp$ret$0 = new ByteString(this.bvt(byteCount));
        break $l$block_0;
      }
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).dvt = function () {
    // Inline function 'okio.internal.commonReadByteArray' call
    return this.bvt(this.svp_1);
  };
  protoOf(Buffer).bvt = function (byteCount) {
    // Inline function 'okio.internal.commonReadByteArray' call
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0 && compare(byteCount, new Long(2147483647, 0)) <= 0)) {
      var message = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (compare(this.svp_1, byteCount) < 0)
      throw EOFException_init_$Create$();
    var result = new Int8Array(convertToInt(byteCount));
    this.evt(result);
    return result;
  };
  protoOf(Buffer).evt = function (sink) {
    // Inline function 'okio.internal.commonReadFully' call
    var offset = 0;
    while (offset < sink.length) {
      var read = this.fvt(sink, offset, sink.length - offset | 0);
      if (read === -1)
        throw EOFException_init_$Create$();
      offset = offset + read | 0;
    }
    return Unit_instance;
  };
  protoOf(Buffer).fvt = function (sink, offset, byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonRead' call
      checkOffsetAndCount(fromInt(sink.length), fromInt(offset), fromInt(byteCount));
      var tmp0_elvis_lhs = this.rvp_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = -1;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s = tmp;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = s.vvp_1 - s.uvp_1 | 0;
      var toCopy = Math.min(byteCount, b);
      var tmp0 = s.tvp_1;
      var tmp6 = s.uvp_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = s.uvp_1 + toCopy | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, sink, offset, tmp6, endIndex);
      s.uvp_1 = s.uvp_1 + toCopy | 0;
      this.svp_1 = subtract(this.svp_1, fromInt(toCopy));
      if (s.uvp_1 === s.vvp_1) {
        this.rvp_1 = s.k3j();
        SegmentPool_instance.jvq(s);
      }
      tmp$ret$0 = toCopy;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).c3 = function () {
    // Inline function 'okio.internal.commonClear' call
    this.is8(this.svp_1);
    return Unit_instance;
  };
  protoOf(Buffer).is8 = function (byteCount) {
    // Inline function 'okio.internal.commonSkip' call
    var byteCount_0 = byteCount;
    while (compare(byteCount_0, new Long(0, 0)) > 0) {
      var tmp0_elvis_lhs = this.rvp_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        throw EOFException_init_$Create$();
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var head = tmp;
      var tmp0 = byteCount_0;
      // Inline function 'okio.minOf' call
      var b = head.vvp_1 - head.uvp_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = fromInt(b);
      var tmp$ret$1 = compare(tmp0, b_0) <= 0 ? tmp0 : b_0;
      var toSkip = convertToInt(tmp$ret$1);
      this.svp_1 = subtract(this.svp_1, fromInt(toSkip));
      byteCount_0 = subtract(byteCount_0, fromInt(toSkip));
      head.uvp_1 = head.uvp_1 + toSkip | 0;
      if (head.uvp_1 === head.vvp_1) {
        this.rvp_1 = head.k3j();
        SegmentPool_instance.jvq(head);
      }
    }
    return Unit_instance;
  };
  protoOf(Buffer).tvq = function (byteString) {
    // Inline function 'okio.internal.commonWrite' call
    var byteCount = byteString.n1();
    byteString.tvs(this, 0, byteCount);
    return this;
  };
  protoOf(Buffer).gvt = function (minimumCapacity) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonWritableSegment' call
      // Inline function 'kotlin.require' call
      if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
        var message = 'unexpected capacity';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      if (this.rvp_1 == null) {
        var result = SegmentPool_instance.ss8();
        this.rvp_1 = result;
        result.zvp_1 = result;
        result.yvp_1 = result;
        tmp$ret$0 = result;
        break $l$block;
      }
      var tail = ensureNotNull(this.rvp_1).zvp_1;
      if ((ensureNotNull(tail).vvp_1 + minimumCapacity | 0) > 8192 || !tail.xvp_1) {
        tail = tail.dvq(SegmentPool_instance.ss8());
      }
      tmp$ret$0 = tail;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).uvq = function (string) {
    return this.hvt(string, 0, string.length);
  };
  protoOf(Buffer).hvt = function (string, beginIndex, endIndex) {
    // Inline function 'okio.internal.commonWriteUtf8' call
    // Inline function 'kotlin.require' call
    if (!(beginIndex >= 0)) {
      var message = 'beginIndex < 0: ' + beginIndex;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(endIndex >= beginIndex)) {
      var message_0 = 'endIndex < beginIndex: ' + endIndex + ' < ' + beginIndex;
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!(endIndex <= string.length)) {
      var message_1 = 'endIndex > string.length: ' + endIndex + ' > ' + string.length;
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
    var i = beginIndex;
    while (i < endIndex) {
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(string, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < 128) {
        var tail = this.gvt(1);
        var data = tail.tvp_1;
        var segmentOffset = tail.vvp_1 - i | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = 8192 - segmentOffset | 0;
        var runLimit = Math.min(endIndex, b);
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        data[segmentOffset + _unary__edvuaz | 0] = toByte(c);
        $l$loop: while (i < runLimit) {
          // Inline function 'kotlin.code' call
          var this_1 = charCodeAt(string, i);
          c = Char__toInt_impl_vasixd(this_1);
          if (c >= 128)
            break $l$loop;
          var _unary__edvuaz_0 = i;
          i = _unary__edvuaz_0 + 1 | 0;
          data[segmentOffset + _unary__edvuaz_0 | 0] = toByte(c);
        }
        var runSize = (i + segmentOffset | 0) - tail.vvp_1 | 0;
        tail.vvp_1 = tail.vvp_1 + runSize | 0;
        this.svp_1 = add(this.svp_1, fromInt(runSize));
      } else if (c < 2048) {
        var tail_0 = this.gvt(2);
        tail_0.tvp_1[tail_0.vvp_1] = toByte(c >> 6 | 192);
        tail_0.tvp_1[tail_0.vvp_1 + 1 | 0] = toByte(c & 63 | 128);
        tail_0.vvp_1 = tail_0.vvp_1 + 2 | 0;
        this.svp_1 = add(this.svp_1, new Long(2, 0));
        i = i + 1 | 0;
      } else if (c < 55296 || c > 57343) {
        var tail_1 = this.gvt(3);
        tail_1.tvp_1[tail_1.vvp_1] = toByte(c >> 12 | 224);
        tail_1.tvp_1[tail_1.vvp_1 + 1 | 0] = toByte(c >> 6 & 63 | 128);
        tail_1.tvp_1[tail_1.vvp_1 + 2 | 0] = toByte(c & 63 | 128);
        tail_1.vvp_1 = tail_1.vvp_1 + 3 | 0;
        this.svp_1 = add(this.svp_1, new Long(3, 0));
        i = i + 1 | 0;
      } else {
        var tmp;
        if ((i + 1 | 0) < endIndex) {
          // Inline function 'kotlin.code' call
          var this_2 = charCodeAt(string, i + 1 | 0);
          tmp = Char__toInt_impl_vasixd(this_2);
        } else {
          tmp = 0;
        }
        var low = tmp;
        if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(63);
          var tmp$ret$11 = Char__toInt_impl_vasixd(this_3);
          this.ivt(tmp$ret$11);
          i = i + 1 | 0;
        } else {
          var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
          var tail_2 = this.gvt(4);
          tail_2.tvp_1[tail_2.vvp_1] = toByte(codePoint >> 18 | 240);
          tail_2.tvp_1[tail_2.vvp_1 + 1 | 0] = toByte(codePoint >> 12 & 63 | 128);
          tail_2.tvp_1[tail_2.vvp_1 + 2 | 0] = toByte(codePoint >> 6 & 63 | 128);
          tail_2.tvp_1[tail_2.vvp_1 + 3 | 0] = toByte(codePoint & 63 | 128);
          tail_2.vvp_1 = tail_2.vvp_1 + 4 | 0;
          this.svp_1 = add(this.svp_1, new Long(4, 0));
          i = i + 2 | 0;
        }
      }
    }
    return this;
  };
  protoOf(Buffer).jvt = function (source) {
    // Inline function 'okio.internal.commonWrite' call
    return this.ovq(source, 0, source.length);
  };
  protoOf(Buffer).ovq = function (source, offset, byteCount) {
    // Inline function 'okio.internal.commonWrite' call
    var offset_0 = offset;
    checkOffsetAndCount(fromInt(source.length), fromInt(offset_0), fromInt(byteCount));
    var limit = offset_0 + byteCount | 0;
    while (offset_0 < limit) {
      var tail = this.gvt(1);
      var tmp0 = limit - offset_0 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = 8192 - tail.vvp_1 | 0;
      var toCopy = Math.min(tmp0, b);
      var tmp2 = tail.tvp_1;
      var tmp4 = tail.vvp_1;
      var tmp6 = offset_0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = offset_0 + toCopy | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = source;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, tmp4, tmp6, endIndex);
      offset_0 = offset_0 + toCopy | 0;
      tail.vvp_1 = tail.vvp_1 + toCopy | 0;
    }
    this.svp_1 = add(this.svp_1, fromInt(byteCount));
    return this;
  };
  protoOf(Buffer).kvt = function (source) {
    // Inline function 'okio.internal.commonWriteAll' call
    var totalBytesRead = new Long(0, 0);
    $l$loop: while (true) {
      var readCount = source.jvr(this, new Long(8192, 0));
      if (equalsLong(readCount, new Long(-1, -1)))
        break $l$loop;
      totalBytesRead = add(totalBytesRead, readCount);
    }
    return totalBytesRead;
  };
  protoOf(Buffer).ivt = function (b) {
    // Inline function 'okio.internal.commonWriteByte' call
    var tail = this.gvt(1);
    var _unary__edvuaz = tail.vvp_1;
    tail.vvp_1 = _unary__edvuaz + 1 | 0;
    tail.tvp_1[_unary__edvuaz] = toByte(b);
    this.svp_1 = add(this.svp_1, new Long(1, 0));
    return this;
  };
  protoOf(Buffer).lvt = function (v) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonWriteDecimalLong' call
      var v_0 = v;
      if (equalsLong(v_0, new Long(0, 0))) {
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(48);
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
        tmp$ret$0 = this.ivt(tmp$ret$1);
        break $l$block_0;
      }
      var negative = false;
      if (compare(v_0, new Long(0, 0)) < 0) {
        v_0 = negate(v_0);
        if (compare(v_0, new Long(0, 0)) < 0) {
          tmp$ret$0 = this.uvq('-9223372036854775808');
          break $l$block_0;
        }
        negative = true;
      }
      var width = access$countDigitsIn$tBufferKt(v_0);
      if (negative) {
        width = width + 1 | 0;
      }
      var tail = this.gvt(width);
      var data = tail.tvp_1;
      var pos = tail.vvp_1 + width | 0;
      while (!equalsLong(v_0, new Long(0, 0))) {
        // Inline function 'kotlin.Long.rem' call
        var this_1 = v_0;
        var tmp$ret$2 = modulo(this_1, fromInt(10));
        var digit = convertToInt(tmp$ret$2);
        pos = pos - 1 | 0;
        data[pos] = get_HEX_DIGIT_BYTES()[digit];
        // Inline function 'kotlin.Long.div' call
        var this_2 = v_0;
        v_0 = divide(this_2, fromInt(10));
      }
      if (negative) {
        pos = pos - 1 | 0;
        var tmp = pos;
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(45);
        var tmp$ret$4 = Char__toInt_impl_vasixd(this_3);
        data[tmp] = toByte(tmp$ret$4);
      }
      tail.vvp_1 = tail.vvp_1 + width | 0;
      this.svp_1 = add(this.svp_1, fromInt(width));
      tmp$ret$0 = this;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).qvp = function (source, byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonWrite' call
      var byteCount_0 = byteCount;
      // Inline function 'kotlin.require' call
      if (!!(source === this)) {
        var message = 'source == this';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      checkOffsetAndCount(source.svp_1, new Long(0, 0), byteCount_0);
      while (compare(byteCount_0, new Long(0, 0)) > 0) {
        if (compare(byteCount_0, fromInt(ensureNotNull(source.rvp_1).vvp_1 - ensureNotNull(source.rvp_1).uvp_1 | 0)) < 0) {
          var tail = !(this.rvp_1 == null) ? ensureNotNull(this.rvp_1).zvp_1 : null;
          var tmp;
          if (!(tail == null) && tail.xvp_1) {
            var tmp0 = byteCount_0;
            // Inline function 'kotlin.Long.plus' call
            var other = tail.vvp_1;
            var tmp0_0 = add(tmp0, fromInt(other));
            // Inline function 'kotlin.Long.minus' call
            var other_0 = tail.wvp_1 ? 0 : tail.uvp_1;
            var tmp$ret$4 = subtract(tmp0_0, fromInt(other_0));
            tmp = compare(tmp$ret$4, new Long(8192, 0)) <= 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            ensureNotNull(source.rvp_1).ivq(tail, convertToInt(byteCount_0));
            source.svp_1 = subtract(source.svp_1, byteCount_0);
            this.svp_1 = add(this.svp_1, byteCount_0);
            tmp$ret$0 = Unit_instance;
            break $l$block;
          } else {
            source.rvp_1 = ensureNotNull(source.rvp_1).evq(convertToInt(byteCount_0));
          }
        }
        var segmentToMove = source.rvp_1;
        var movedByteCount = fromInt(ensureNotNull(segmentToMove).vvp_1 - segmentToMove.uvp_1 | 0);
        source.rvp_1 = segmentToMove.k3j();
        if (this.rvp_1 == null) {
          this.rvp_1 = segmentToMove;
          segmentToMove.zvp_1 = segmentToMove;
          segmentToMove.yvp_1 = segmentToMove.zvp_1;
        } else {
          var tail_0 = ensureNotNull(this.rvp_1).zvp_1;
          tail_0 = ensureNotNull(tail_0).dvq(segmentToMove);
          tail_0.hvq();
        }
        source.svp_1 = subtract(source.svp_1, movedByteCount);
        this.svp_1 = add(this.svp_1, movedByteCount);
        byteCount_0 = subtract(byteCount_0, movedByteCount);
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).jvr = function (sink, byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonRead' call
      var byteCount_0 = byteCount;
      // Inline function 'kotlin.require' call
      if (!(compare(byteCount_0, new Long(0, 0)) >= 0)) {
        var message = 'byteCount < 0: ' + byteCount_0.toString();
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      if (equalsLong(this.svp_1, new Long(0, 0))) {
        tmp$ret$0 = new Long(-1, -1);
        break $l$block;
      }
      if (compare(byteCount_0, this.svp_1) > 0)
        byteCount_0 = this.svp_1;
      sink.qvp(this, byteCount_0);
      tmp$ret$0 = byteCount_0;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).mvt = function (b, fromIndex, toIndex) {
    var tmp$ret$0;
    $l$block_10: {
      // Inline function 'okio.internal.commonIndexOf' call
      var fromIndex_0 = fromIndex;
      var toIndex_0 = toIndex;
      // Inline function 'kotlin.require' call
      if (!(compare(new Long(0, 0), fromIndex_0) <= 0 ? compare(fromIndex_0, toIndex_0) <= 0 : false)) {
        var message = 'size=' + this.svp_1.toString() + ' fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex_0.toString();
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      if (compare(toIndex_0, this.svp_1) > 0)
        toIndex_0 = this.svp_1;
      if (equalsLong(fromIndex_0, toIndex_0)) {
        tmp$ret$0 = new Long(-1, -1);
        break $l$block_10;
      }
      var tmp2 = fromIndex_0;
      $l$block_11: {
        // Inline function 'okio.internal.seek' call
        var tmp0_elvis_lhs = this.rvp_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var offset = new Long(-1, -1);
          var tmp_0;
          if (null == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_10;
          } else {
            tmp_0 = null;
          }
          var s = tmp_0;
          var offset_0 = offset;
          while (compare(offset_0, toIndex_0) < 0) {
            var data = s.tvp_1;
            var tmp0 = fromInt(s.vvp_1);
            // Inline function 'kotlin.comparisons.minOf' call
            var b_0 = subtract(add(numberToLong(s.uvp_1), toIndex_0), offset_0);
            var tmp$ret$5 = compare(tmp0, b_0) <= 0 ? tmp0 : b_0;
            var limit = convertToInt(tmp$ret$5);
            var pos = convertToInt(subtract(add(numberToLong(s.uvp_1), fromIndex_0), offset_0));
            while (pos < limit) {
              if (data[pos] === b) {
                tmp$ret$0 = add(numberToLong(pos - s.uvp_1 | 0), offset_0);
                break $l$block_10;
              }
              pos = pos + 1 | 0;
            }
            offset_0 = add(offset_0, fromInt(s.vvp_1 - s.uvp_1 | 0));
            fromIndex_0 = offset_0;
            s = ensureNotNull(s.yvp_1);
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_10;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s_0 = tmp;
        if (compare(subtract(this.svp_1, tmp2), tmp2) < 0) {
          var offset_1 = this.svp_1;
          while (compare(offset_1, tmp2) > 0) {
            s_0 = ensureNotNull(s_0.zvp_1);
            offset_1 = subtract(offset_1, fromInt(s_0.vvp_1 - s_0.uvp_1 | 0));
          }
          var tmp0_0 = s_0;
          var offset_2 = offset_1;
          var tmp_1;
          if (tmp0_0 == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_10;
          } else {
            tmp_1 = tmp0_0;
          }
          var s_1 = tmp_1;
          var offset_3 = offset_2;
          while (compare(offset_3, toIndex_0) < 0) {
            var data_0 = s_1.tvp_1;
            var tmp0_1 = fromInt(s_1.vvp_1);
            // Inline function 'kotlin.comparisons.minOf' call
            var b_1 = subtract(add(numberToLong(s_1.uvp_1), toIndex_0), offset_3);
            var tmp$ret$7 = compare(tmp0_1, b_1) <= 0 ? tmp0_1 : b_1;
            var limit_0 = convertToInt(tmp$ret$7);
            var pos_0 = convertToInt(subtract(add(numberToLong(s_1.uvp_1), fromIndex_0), offset_3));
            while (pos_0 < limit_0) {
              if (data_0[pos_0] === b) {
                tmp$ret$0 = add(numberToLong(pos_0 - s_1.uvp_1 | 0), offset_3);
                break $l$block_10;
              }
              pos_0 = pos_0 + 1 | 0;
            }
            offset_3 = add(offset_3, fromInt(s_1.vvp_1 - s_1.uvp_1 | 0));
            fromIndex_0 = offset_3;
            s_1 = ensureNotNull(s_1.yvp_1);
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_10;
        } else {
          var offset_4 = new Long(0, 0);
          $l$loop: while (true) {
            var tmp0_2 = offset_4;
            // Inline function 'kotlin.Long.plus' call
            var other = s_0.vvp_1 - s_0.uvp_1 | 0;
            var nextOffset = add(tmp0_2, fromInt(other));
            if (compare(nextOffset, tmp2) > 0)
              break $l$loop;
            s_0 = ensureNotNull(s_0.yvp_1);
            offset_4 = nextOffset;
          }
          var tmp0_3 = s_0;
          var offset_5 = offset_4;
          var tmp_2;
          if (tmp0_3 == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_10;
          } else {
            tmp_2 = tmp0_3;
          }
          var s_2 = tmp_2;
          var offset_6 = offset_5;
          while (compare(offset_6, toIndex_0) < 0) {
            var data_1 = s_2.tvp_1;
            var tmp0_4 = fromInt(s_2.vvp_1);
            // Inline function 'kotlin.comparisons.minOf' call
            var b_2 = subtract(add(numberToLong(s_2.uvp_1), toIndex_0), offset_6);
            var tmp$ret$10 = compare(tmp0_4, b_2) <= 0 ? tmp0_4 : b_2;
            var limit_1 = convertToInt(tmp$ret$10);
            var pos_1 = convertToInt(subtract(add(numberToLong(s_2.uvp_1), fromIndex_0), offset_6));
            while (pos_1 < limit_1) {
              if (data_1[pos_1] === b) {
                tmp$ret$0 = add(numberToLong(pos_1 - s_2.uvp_1 | 0), offset_6);
                break $l$block_10;
              }
              pos_1 = pos_1 + 1 | 0;
            }
            offset_6 = add(offset_6, fromInt(s_2.vvp_1 - s_2.uvp_1 | 0));
            fromIndex_0 = offset_6;
            s_2 = ensureNotNull(s_2.yvp_1);
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_10;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).bvr = function (targetBytes) {
    return this.nvt(targetBytes, new Long(0, 0));
  };
  protoOf(Buffer).nvt = function (targetBytes, fromIndex) {
    var tmp$ret$0;
    $l$block_12: {
      // Inline function 'okio.internal.commonIndexOfElement' call
      var fromIndex_0 = fromIndex;
      // Inline function 'kotlin.require' call
      if (!(compare(fromIndex_0, new Long(0, 0)) >= 0)) {
        var message = 'fromIndex < 0: ' + fromIndex_0.toString();
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      var tmp2 = fromIndex_0;
      $l$block_13: {
        // Inline function 'okio.internal.seek' call
        var tmp0_elvis_lhs = this.rvp_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var offset = new Long(-1, -1);
          var tmp_0;
          if (null == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_12;
          } else {
            tmp_0 = null;
          }
          var s = tmp_0;
          var offset_0 = offset;
          if (targetBytes.n1() === 2) {
            var b0 = targetBytes.l1(0);
            var b1 = targetBytes.l1(1);
            while (compare(offset_0, this.svp_1) < 0) {
              var data = s.tvp_1;
              var pos = convertToInt(subtract(add(numberToLong(s.uvp_1), fromIndex_0), offset_0));
              var limit = s.vvp_1;
              while (pos < limit) {
                var b = data[pos];
                if (b === b0 || b === b1) {
                  tmp$ret$0 = add(numberToLong(pos - s.uvp_1 | 0), offset_0);
                  break $l$block_12;
                }
                pos = pos + 1 | 0;
              }
              offset_0 = add(offset_0, fromInt(s.vvp_1 - s.uvp_1 | 0));
              fromIndex_0 = offset_0;
              s = ensureNotNull(s.yvp_1);
            }
          } else {
            var targetByteArray = targetBytes.nvq();
            while (compare(offset_0, this.svp_1) < 0) {
              var data_0 = s.tvp_1;
              var pos_0 = convertToInt(subtract(add(numberToLong(s.uvp_1), fromIndex_0), offset_0));
              var limit_0 = s.vvp_1;
              while (pos_0 < limit_0) {
                var b_0 = data_0[pos_0];
                var inductionVariable = 0;
                var last = targetByteArray.length;
                while (inductionVariable < last) {
                  var t = targetByteArray[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  if (b_0 === t) {
                    tmp$ret$0 = add(numberToLong(pos_0 - s.uvp_1 | 0), offset_0);
                    break $l$block_12;
                  }
                }
                pos_0 = pos_0 + 1 | 0;
              }
              offset_0 = add(offset_0, fromInt(s.vvp_1 - s.uvp_1 | 0));
              fromIndex_0 = offset_0;
              s = ensureNotNull(s.yvp_1);
            }
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_12;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s_0 = tmp;
        if (compare(subtract(this.svp_1, tmp2), tmp2) < 0) {
          var offset_1 = this.svp_1;
          while (compare(offset_1, tmp2) > 0) {
            s_0 = ensureNotNull(s_0.zvp_1);
            offset_1 = subtract(offset_1, fromInt(s_0.vvp_1 - s_0.uvp_1 | 0));
          }
          var tmp0 = s_0;
          var offset_2 = offset_1;
          var tmp_1;
          if (tmp0 == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_12;
          } else {
            tmp_1 = tmp0;
          }
          var s_1 = tmp_1;
          var offset_3 = offset_2;
          if (targetBytes.n1() === 2) {
            var b0_0 = targetBytes.l1(0);
            var b1_0 = targetBytes.l1(1);
            while (compare(offset_3, this.svp_1) < 0) {
              var data_1 = s_1.tvp_1;
              var pos_1 = convertToInt(subtract(add(numberToLong(s_1.uvp_1), fromIndex_0), offset_3));
              var limit_1 = s_1.vvp_1;
              while (pos_1 < limit_1) {
                var b_1 = data_1[pos_1];
                if (b_1 === b0_0 || b_1 === b1_0) {
                  tmp$ret$0 = add(numberToLong(pos_1 - s_1.uvp_1 | 0), offset_3);
                  break $l$block_12;
                }
                pos_1 = pos_1 + 1 | 0;
              }
              offset_3 = add(offset_3, fromInt(s_1.vvp_1 - s_1.uvp_1 | 0));
              fromIndex_0 = offset_3;
              s_1 = ensureNotNull(s_1.yvp_1);
            }
          } else {
            var targetByteArray_0 = targetBytes.nvq();
            while (compare(offset_3, this.svp_1) < 0) {
              var data_2 = s_1.tvp_1;
              var pos_2 = convertToInt(subtract(add(numberToLong(s_1.uvp_1), fromIndex_0), offset_3));
              var limit_2 = s_1.vvp_1;
              while (pos_2 < limit_2) {
                var b_2 = data_2[pos_2];
                var inductionVariable_0 = 0;
                var last_0 = targetByteArray_0.length;
                while (inductionVariable_0 < last_0) {
                  var t_0 = targetByteArray_0[inductionVariable_0];
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  if (b_2 === t_0) {
                    tmp$ret$0 = add(numberToLong(pos_2 - s_1.uvp_1 | 0), offset_3);
                    break $l$block_12;
                  }
                }
                pos_2 = pos_2 + 1 | 0;
              }
              offset_3 = add(offset_3, fromInt(s_1.vvp_1 - s_1.uvp_1 | 0));
              fromIndex_0 = offset_3;
              s_1 = ensureNotNull(s_1.yvp_1);
            }
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_12;
        } else {
          var offset_4 = new Long(0, 0);
          $l$loop: while (true) {
            var tmp0_0 = offset_4;
            // Inline function 'kotlin.Long.plus' call
            var other = s_0.vvp_1 - s_0.uvp_1 | 0;
            var nextOffset = add(tmp0_0, fromInt(other));
            if (compare(nextOffset, tmp2) > 0)
              break $l$loop;
            s_0 = ensureNotNull(s_0.yvp_1);
            offset_4 = nextOffset;
          }
          var tmp0_1 = s_0;
          var offset_5 = offset_4;
          var tmp_2;
          if (tmp0_1 == null) {
            tmp$ret$0 = new Long(-1, -1);
            break $l$block_12;
          } else {
            tmp_2 = tmp0_1;
          }
          var s_2 = tmp_2;
          var offset_6 = offset_5;
          if (targetBytes.n1() === 2) {
            var b0_1 = targetBytes.l1(0);
            var b1_1 = targetBytes.l1(1);
            while (compare(offset_6, this.svp_1) < 0) {
              var data_3 = s_2.tvp_1;
              var pos_3 = convertToInt(subtract(add(numberToLong(s_2.uvp_1), fromIndex_0), offset_6));
              var limit_3 = s_2.vvp_1;
              while (pos_3 < limit_3) {
                var b_3 = data_3[pos_3];
                if (b_3 === b0_1 || b_3 === b1_1) {
                  tmp$ret$0 = add(numberToLong(pos_3 - s_2.uvp_1 | 0), offset_6);
                  break $l$block_12;
                }
                pos_3 = pos_3 + 1 | 0;
              }
              offset_6 = add(offset_6, fromInt(s_2.vvp_1 - s_2.uvp_1 | 0));
              fromIndex_0 = offset_6;
              s_2 = ensureNotNull(s_2.yvp_1);
            }
          } else {
            var targetByteArray_1 = targetBytes.nvq();
            while (compare(offset_6, this.svp_1) < 0) {
              var data_4 = s_2.tvp_1;
              var pos_4 = convertToInt(subtract(add(numberToLong(s_2.uvp_1), fromIndex_0), offset_6));
              var limit_4 = s_2.vvp_1;
              while (pos_4 < limit_4) {
                var b_4 = data_4[pos_4];
                var inductionVariable_1 = 0;
                var last_1 = targetByteArray_1.length;
                while (inductionVariable_1 < last_1) {
                  var t_1 = targetByteArray_1[inductionVariable_1];
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  if (b_4 === t_1) {
                    tmp$ret$0 = add(numberToLong(pos_4 - s_2.uvp_1 | 0), offset_6);
                    break $l$block_12;
                  }
                }
                pos_4 = pos_4 + 1 | 0;
              }
              offset_6 = add(offset_6, fromInt(s_2.vvp_1 - s_2.uvp_1 | 0));
              fromIndex_0 = offset_6;
              s_2 = ensureNotNull(s_2.yvp_1);
            }
          }
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_12;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).avr = function (offset, bytes) {
    return this.kvr(offset, bytes, 0, bytes.n1());
  };
  protoOf(Buffer).kvr = function (offset, bytes, bytesOffset, byteCount) {
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'okio.internal.commonRangeEquals' call
      if (byteCount < 0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      var tmp;
      if (compare(offset, new Long(0, 0)) < 0) {
        tmp = true;
      } else {
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$1 = add(offset, fromInt(byteCount));
        tmp = compare(tmp$ret$1, this.svp_1) > 0;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      if (bytesOffset < 0 || (bytesOffset + byteCount | 0) > bytes.n1()) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      if (byteCount === 0) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      // Inline function 'kotlin.Long.plus' call
      var tmp0_toIndex = add(offset, fromInt(1));
      tmp$ret$0 = !equalsLong(commonIndexOf(this, bytes, offset, tmp0_toIndex, bytesOffset, byteCount), new Long(-1, -1));
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).k9 = function () {
    return Unit_instance;
  };
  protoOf(Buffer).j4 = function () {
    return Unit_instance;
  };
  protoOf(Buffer).equals = function (other) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'okio.internal.commonEquals' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      if (!(other instanceof Buffer)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      if (!equalsLong(this.svp_1, other.svp_1)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      if (equalsLong(this.svp_1, new Long(0, 0))) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      var sa = ensureNotNull(this.rvp_1);
      var sb = ensureNotNull(other.rvp_1);
      var posA = sa.uvp_1;
      var posB = sb.uvp_1;
      var pos = new Long(0, 0);
      var count;
      while (compare(pos, this.svp_1) < 0) {
        var tmp0 = sa.vvp_1 - posA | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = sb.vvp_1 - posB | 0;
        var tmp$ret$1 = Math.min(tmp0, b);
        count = fromInt(tmp$ret$1);
        var inductionVariable = new Long(0, 0);
        if (compare(inductionVariable, count) < 0)
          do {
            var i = inductionVariable;
            inductionVariable = add(inductionVariable, new Long(1, 0));
            var tmp = sa.tvp_1;
            var _unary__edvuaz = posA;
            posA = _unary__edvuaz + 1 | 0;
            var tmp_0 = tmp[_unary__edvuaz];
            var tmp_1 = sb.tvp_1;
            var _unary__edvuaz_0 = posB;
            posB = _unary__edvuaz_0 + 1 | 0;
            if (!(tmp_0 === tmp_1[_unary__edvuaz_0])) {
              tmp$ret$0 = false;
              break $l$block_3;
            }
          }
           while (compare(inductionVariable, count) < 0);
        if (posA === sa.vvp_1) {
          sa = ensureNotNull(sa.yvp_1);
          posA = sa.uvp_1;
        }
        if (posB === sb.vvp_1) {
          sb = ensureNotNull(sb.yvp_1);
          posB = sb.uvp_1;
        }
        pos = add(pos, count);
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).hashCode = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var tmp0_elvis_lhs = this.rvp_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = 0;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s = tmp;
      var result = 1;
      do {
        var pos = s.uvp_1;
        var limit = s.vvp_1;
        while (pos < limit) {
          result = imul(31, result) + s.tvp_1[pos] | 0;
          pos = pos + 1 | 0;
        }
        s = ensureNotNull(s.yvp_1);
      }
       while (!(s === this.rvp_1));
      tmp$ret$0 = result;
    }
    return tmp$ret$0;
  };
  protoOf(Buffer).toString = function () {
    return this.f5s().toString();
  };
  protoOf(Buffer).f5s = function () {
    // Inline function 'okio.internal.commonSnapshot' call
    // Inline function 'kotlin.check' call
    if (!(compare(this.svp_1, new Long(2147483647, 0)) <= 0)) {
      var message = 'size > Int.MAX_VALUE: ' + this.svp_1.toString();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return this.cvt(convertToInt(this.svp_1));
  };
  protoOf(Buffer).cvt = function (byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonSnapshot' call
      if (byteCount === 0) {
        tmp$ret$0 = Companion_getInstance_2().evr_1;
        break $l$block;
      }
      checkOffsetAndCount(this.svp_1, new Long(0, 0), fromInt(byteCount));
      var offset = 0;
      var segmentCount = 0;
      var s = this.rvp_1;
      while (offset < byteCount) {
        if (ensureNotNull(s).vvp_1 === s.uvp_1) {
          throw AssertionError_init_$Create$('s.limit == s.pos');
        }
        offset = offset + (s.vvp_1 - s.uvp_1 | 0) | 0;
        segmentCount = segmentCount + 1 | 0;
        s = s.yvp_1;
      }
      // Inline function 'kotlin.arrayOfNulls' call
      var size = segmentCount;
      var segments = Array(size);
      var directory = new Int32Array(imul(segmentCount, 2));
      offset = 0;
      segmentCount = 0;
      s = this.rvp_1;
      while (offset < byteCount) {
        segments[segmentCount] = ensureNotNull(s).tvp_1;
        offset = offset + (s.vvp_1 - s.uvp_1 | 0) | 0;
        var tmp = segmentCount;
        // Inline function 'kotlin.comparisons.minOf' call
        var a = offset;
        directory[tmp] = Math.min(a, byteCount);
        directory[segmentCount + segments.length | 0] = s.uvp_1;
        s.wvp_1 = true;
        segmentCount = segmentCount + 1 | 0;
        s = s.yvp_1;
      }
      tmp$ret$0 = new SegmentedByteString(isArray(segments) ? segments : THROW_CCE(), directory);
    }
    return tmp$ret$0;
  };
  function IOException_init_$Init$(message, $this) {
    IOException.call($this, message, null);
    return $this;
  }
  function IOException_init_$Create$(message) {
    var tmp = IOException_init_$Init$(message, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$);
    return tmp;
  }
  function IOException_init_$Init$_0($this) {
    IOException.call($this, null, null);
    return $this;
  }
  function IOException_init_$Create$_0() {
    var tmp = IOException_init_$Init$_0(objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$_0);
    return tmp;
  }
  function IOException(message, cause) {
    Exception_init_$Init$(message, cause, this);
    captureStack(this, IOException);
  }
  function EOFException_init_$Init$($this) {
    EOFException.call($this, null);
    return $this;
  }
  function EOFException_init_$Create$() {
    var tmp = EOFException_init_$Init$(objectCreate(protoOf(EOFException)));
    captureStack(tmp, EOFException_init_$Create$);
    return tmp;
  }
  function EOFException(message) {
    IOException_init_$Init$(message, this);
    captureStack(this, EOFException);
  }
  function ArrayIndexOutOfBoundsException(message) {
    IndexOutOfBoundsException_init_$Init$(message, this);
    captureStack(this, ArrayIndexOutOfBoundsException);
  }
  function asUtf8ToByteArray(_this__u8e3s4) {
    return commonAsUtf8ToByteArray(_this__u8e3s4);
  }
  function toUtf8String(_this__u8e3s4) {
    return commonToUtf8String(_this__u8e3s4);
  }
  function Companion_3() {
    Companion_instance_3 = this;
    this.svq_1 = get_PLATFORM_DIRECTORY_SEPARATOR();
  }
  protoOf(Companion_3).ovt = function (_this__u8e3s4, normalize) {
    return commonToPath(_this__u8e3s4, normalize);
  };
  protoOf(Companion_3).gvs = function (_this__u8e3s4, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.ovt(_this__u8e3s4, normalize) : $super.ovt.call(this, _this__u8e3s4, normalize);
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Path(bytes) {
    Companion_getInstance_3();
    this.pvq_1 = bytes;
  }
  protoOf(Path).rvq = function () {
    // Inline function 'okio.internal.commonIsAbsolute' call
    return !(access$rootLength$tPathKt(this) === -1);
  };
  protoOf(Path).qvq = function () {
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'okio.internal.commonVolumeLetter' call
      if (!(this.pvq_1.zvq(access$_get_SLASH_$tPathKt_oiy1wy()) === -1)) {
        tmp$ret$0 = null;
        break $l$block_2;
      }
      if (this.pvq_1.n1() < 2) {
        tmp$ret$0 = null;
        break $l$block_2;
      }
      var tmp = this.pvq_1.l1(1);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(58);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
      if (!(tmp === toByte(tmp$ret$1))) {
        tmp$ret$0 = null;
        break $l$block_2;
      }
      var c = numberToChar(this.pvq_1.l1(0));
      if (!(_Char___init__impl__6a9atx(97) <= c ? c <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= c ? c <= _Char___init__impl__6a9atx(90) : false)) {
        tmp$ret$0 = null;
        break $l$block_2;
      }
      tmp$ret$0 = c;
    }
    return tmp$ret$0;
  };
  protoOf(Path).k1a = function () {
    var tmp$ret$0;
    $l$block_7: {
      // Inline function 'okio.internal.commonParent' call
      if (this.pvq_1.equals(access$_get_DOT_$tPathKt_c0s3mi()) || this.pvq_1.equals(access$_get_SLASH_$tPathKt_oiy1wy()) || this.pvq_1.equals(access$_get_BACKSLASH_$tPathKt_hofl47()) || access$lastSegmentIsDotDot$tPathKt(this)) {
        tmp$ret$0 = null;
        break $l$block_7;
      }
      var lastSlash = access$_get_indexOfLastSlash_$tPathKt_czkh05(this);
      var tmp;
      if (lastSlash === 2) {
        var tmp_0 = this.qvq();
        tmp = !((tmp_0 == null ? null : new Char(tmp_0)) == null);
      } else {
        tmp = false;
      }
      if (tmp) {
        if (this.pvq_1.n1() === 3) {
          tmp$ret$0 = null;
          break $l$block_7;
        }
        tmp$ret$0 = new Path(this.pvq_1.pvs(VOID, 3));
        break $l$block_7;
      } else {
        if (lastSlash === 1 && this.pvq_1.vvs(access$_get_BACKSLASH_$tPathKt_hofl47())) {
          tmp$ret$0 = null;
          break $l$block_7;
        } else {
          var tmp_1;
          if (lastSlash === -1) {
            var tmp_2 = this.qvq();
            tmp_1 = !((tmp_2 == null ? null : new Char(tmp_2)) == null);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            if (this.pvq_1.n1() === 2) {
              tmp$ret$0 = null;
              break $l$block_7;
            }
            tmp$ret$0 = new Path(this.pvq_1.pvs(VOID, 2));
            break $l$block_7;
          } else {
            if (lastSlash === -1) {
              tmp$ret$0 = new Path(access$_get_DOT_$tPathKt_c0s3mi());
              break $l$block_7;
            } else {
              if (lastSlash === 0) {
                tmp$ret$0 = new Path(this.pvq_1.pvs(VOID, 1));
                break $l$block_7;
              } else {
                tmp$ret$0 = new Path(this.pvq_1.pvs(VOID, lastSlash));
                break $l$block_7;
              }
            }
          }
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Path).pvt = function (child) {
    // Inline function 'okio.internal.commonResolve' call
    // Inline function 'okio.internal.commonResolve' call
    var child_0 = (new Buffer()).uvq(child);
    return commonResolve(this, toPath(child_0, false), false);
  };
  protoOf(Path).qvt = function (other) {
    // Inline function 'okio.internal.commonCompareTo' call
    return this.pvq_1.zvs(other.pvq_1);
  };
  protoOf(Path).d = function (other) {
    return this.qvt(other instanceof Path ? other : THROW_CCE());
  };
  protoOf(Path).equals = function (other) {
    // Inline function 'okio.internal.commonEquals' call
    var tmp;
    if (other instanceof Path) {
      tmp = other.pvq_1.equals(this.pvq_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Path).hashCode = function () {
    // Inline function 'okio.internal.commonHashCode' call
    return this.pvq_1.hashCode();
  };
  protoOf(Path).toString = function () {
    // Inline function 'okio.internal.commonToString' call
    return this.pvq_1.lvs();
  };
  function RealBufferedSink(sink) {
    this.rvt_1 = sink;
    this.svt_1 = false;
    this.tvt_1 = new Buffer();
  }
  protoOf(RealBufferedSink).qvp = function (source, byteCount) {
    // Inline function 'okio.internal.commonWrite' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.tvt_1.qvp(source, byteCount);
    this.uvt();
    return Unit_instance;
  };
  protoOf(RealBufferedSink).uvq = function (string) {
    // Inline function 'okio.internal.commonWriteUtf8' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.tvt_1.uvq(string);
    return this.uvt();
  };
  protoOf(RealBufferedSink).kvt = function (source) {
    // Inline function 'okio.internal.commonWriteAll' call
    var totalBytesRead = new Long(0, 0);
    $l$loop: while (true) {
      var readCount = source.jvr(this.tvt_1, new Long(8192, 0));
      if (equalsLong(readCount, new Long(-1, -1)))
        break $l$loop;
      totalBytesRead = add(totalBytesRead, readCount);
      this.uvt();
    }
    return totalBytesRead;
  };
  protoOf(RealBufferedSink).ivt = function (b) {
    // Inline function 'okio.internal.commonWriteByte' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.tvt_1.ivt(b);
    return this.uvt();
  };
  protoOf(RealBufferedSink).lvt = function (v) {
    // Inline function 'okio.internal.commonWriteDecimalLong' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.tvt_1.lvt(v);
    return this.uvt();
  };
  protoOf(RealBufferedSink).uvt = function () {
    // Inline function 'okio.internal.commonEmitCompleteSegments' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var byteCount = this.tvt_1.avt();
    if (compare(byteCount, new Long(0, 0)) > 0) {
      this.rvt_1.qvp(this.tvt_1, byteCount);
    }
    return this;
  };
  protoOf(RealBufferedSink).k9 = function () {
    // Inline function 'okio.internal.commonFlush' call
    // Inline function 'kotlin.check' call
    if (!!this.svt_1) {
      var message = 'closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (compare(this.tvt_1.svp_1, new Long(0, 0)) > 0) {
      this.rvt_1.qvp(this.tvt_1, this.tvt_1.svp_1);
    }
    this.rvt_1.k9();
    return Unit_instance;
  };
  protoOf(RealBufferedSink).j4 = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonClose' call
      if (this.svt_1) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      var thrown = null;
      try {
        if (compare(this.tvt_1.svp_1, new Long(0, 0)) > 0) {
          this.rvt_1.qvp(this.tvt_1, this.tvt_1.svp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          thrown = e;
        } else {
          throw $p;
        }
      }
      try {
        this.rvt_1.j4();
      } catch ($p_0) {
        if ($p_0 instanceof Error) {
          var e_0 = $p_0;
          if (thrown == null)
            thrown = e_0;
        } else {
          throw $p_0;
        }
      }
      this.svt_1 = true;
      if (!(thrown == null))
        throw thrown;
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  protoOf(RealBufferedSink).toString = function () {
    // Inline function 'okio.internal.commonToString' call
    return 'buffer(' + toString(this.rvt_1) + ')';
  };
  function RealBufferedSource(source) {
    this.gvr_1 = source;
    this.hvr_1 = false;
    this.ivr_1 = new Buffer();
  }
  protoOf(RealBufferedSource).jvr = function (sink, byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonRead' call
      // Inline function 'kotlin.require' call
      if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
        var message = 'byteCount < 0: ' + byteCount.toString();
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.check' call
      if (!!this.hvr_1) {
        var message_0 = 'closed';
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
      if (equalsLong(this.ivr_1.svp_1, new Long(0, 0))) {
        if (equalsLong(byteCount, new Long(0, 0))) {
          tmp$ret$0 = new Long(0, 0);
          break $l$block_0;
        }
        var read = this.gvr_1.jvr(this.ivr_1, new Long(8192, 0));
        if (equalsLong(read, new Long(-1, -1))) {
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_0;
        }
      }
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.ivr_1.svp_1;
      var toRead = compare(byteCount, b) <= 0 ? byteCount : b;
      tmp$ret$0 = this.ivr_1.jvr(sink, toRead);
    }
    return tmp$ret$0;
  };
  protoOf(RealBufferedSource).dvt = function () {
    // Inline function 'okio.internal.commonReadByteArray' call
    this.ivr_1.kvt(this.gvr_1);
    return this.ivr_1.dvt();
  };
  protoOf(RealBufferedSource).mvt = function (b, fromIndex, toIndex) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonIndexOf' call
      var fromIndex_0 = fromIndex;
      // Inline function 'kotlin.check' call
      if (!!this.hvr_1) {
        var message = 'closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!(compare(new Long(0, 0), fromIndex_0) <= 0 ? compare(fromIndex_0, toIndex) <= 0 : false)) {
        var message_0 = 'fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex.toString();
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      while (compare(fromIndex_0, toIndex) < 0) {
        var result = this.ivr_1.mvt(b, fromIndex_0, toIndex);
        if (!equalsLong(result, new Long(-1, -1))) {
          tmp$ret$0 = result;
          break $l$block_0;
        }
        var lastBufferSize = this.ivr_1.svp_1;
        if (compare(lastBufferSize, toIndex) >= 0 || equalsLong(this.gvr_1.jvr(this.ivr_1, new Long(8192, 0)), new Long(-1, -1))) {
          tmp$ret$0 = new Long(-1, -1);
          break $l$block_0;
        }
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = fromIndex_0;
        fromIndex_0 = compare(a, lastBufferSize) >= 0 ? a : lastBufferSize;
      }
      tmp$ret$0 = new Long(-1, -1);
    }
    return tmp$ret$0;
  };
  protoOf(RealBufferedSource).avr = function (offset, bytes) {
    return this.kvr(offset, bytes, 0, bytes.n1());
  };
  protoOf(RealBufferedSource).kvr = function (offset, bytes, bytesOffset, byteCount) {
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'okio.internal.commonRangeEquals' call
      // Inline function 'kotlin.check' call
      if (!!this.hvr_1) {
        var message = 'closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      if (byteCount < 0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      if (compare(offset, new Long(0, 0)) < 0) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      if (bytesOffset < 0 || (bytesOffset + byteCount | 0) > bytes.n1()) {
        tmp$ret$0 = false;
        break $l$block_2;
      }
      if (byteCount === 0) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$3 = add(offset, fromInt(1));
      tmp$ret$0 = !equalsLong(commonIndexOf_0(this, bytes, bytesOffset, byteCount, offset, tmp$ret$3), new Long(-1, -1));
    }
    return tmp$ret$0;
  };
  protoOf(RealBufferedSource).j4 = function () {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonClose' call
      if (this.hvr_1) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      this.hvr_1 = true;
      this.gvr_1.j4();
      this.ivr_1.c3();
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  protoOf(RealBufferedSource).toString = function () {
    // Inline function 'okio.internal.commonToString' call
    return 'buffer(' + toString(this.gvr_1) + ')';
  };
  function SegmentPool() {
    this.fvq_1 = 0;
    this.gvq_1 = 0;
  }
  protoOf(SegmentPool).ss8 = function () {
    return Segment_init_$Create$();
  };
  protoOf(SegmentPool).jvq = function (segment) {
  };
  var SegmentPool_instance;
  function SegmentPool_getInstance() {
    return SegmentPool_instance;
  }
  //region block: init
  Companion_instance = new Companion();
  SegmentPool_instance = new SegmentPool();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_2;
  _.$_$.b = Companion_getInstance_3;
  _.$_$.c = Buffer;
  _.$_$.d = FileSystem;
  _.$_$.e = ForwardingFileSystem;
  _.$_$.f = IOException;
  _.$_$.g = Path;
  _.$_$.h = blackholeSink;
  _.$_$.i = buffer;
  _.$_$.j = buffer_0;
  //endregion
  return _;
}));

//# sourceMappingURL=okio-parent-okio.js.map
